export default {
  component: {
    federatedLoginError: {
      heading: 'Kirjautuminen epäonnistui',
      content: 'Emme valitettavasti pystyneet kirjaamaan sinua sisään. Ole hyvä ja yritä myöhemmin uudestaan. Jos ongelma jatkuu, ole yhteydessä tukeemme.',
    },

    accountMenu: {
      myAccount: 'Oma tilini',
      billing: 'Laskutus',
      userManagement: 'Käyttäjien hallinta',
      organisationProfile: 'Organisaation asetukset',
      statistics: 'Tilastot',
      videos: 'Videokirjasto',
    },

    adminNavigationBar: {
      dashboard: 'Etusivulle',
      backToMainMenu: 'Takaisin päävalikkoon',
      noTutorial: 'Tällä sivulla ei vielä ole opastusta',
    },

    actionLog: {
      noAction: 'Ei tapahtumia',
      show: 'Näytä sisältö',
      hide: 'Piilota sisältö',
      action: {
        comment: 'kommentoi hakemusta',
        invite: 'kutsui haastatteluun',
        schedulingInvite: 'Lähetti hakijalle viestin haastatteluajan valitsemisesta',
        reScheduled: 'Muutti haastattelun ajankohdan',
        addedCandidateToRound: 'lisäsi hakijan haastattelukierrokselle',
        selectedInterviewTime: 'Hakija valitsi ajan haastattelulle',
        reInvite: 'uudelleenlähetti haastattelukutsun hakijalle',
        smsInvite: 'kutsui haastatteluun tekstiviestillä',
        smsReInvite: 'uudelleenlähetti haastattelukutsun hakijalle tekstiviestillä',
        videoResponse: 'Hakija vastasi videokysymykseen',
        message: 'lähetti sähköpostin',
        smsMessage: 'lähetti tekstiviestin',
        personalInterviewMessage: 'lähetti kutsun sovittuun tapaamiseen',
        PersonalInterviewInvitationRemoved: 'poisti aikasemman kutsun sovittuun tapaamiseen',
        videoMessage: 'lähetti videoviestin',
        applicationCreated: 'Hakemus jätetty',
        stageChanged: placeholderKeys => `siirsi hakijan vaiheeseen ${placeholderKeys.stage}`,
        answeredToInterview: placeholder => `Hakija vastasi haastatteluun ${placeholder.opening}`,
        applicationCreatedByAdmin: 'lisäsi hakemuksen',
        applicationUpdated: 'Hakemusta päivitetty',
        candidateUpdated: 'Hakemusta päivitetty',
        introductionToOne: placeholders => `Hakija esiteltiin ${placeholders.introducee}:lle`,
        introductionToMany: placeholders => `Hakija esiteltiin ${placeholders.introduceeCount} vastaanottajalle`,
        calendarEventCreated: placeholders => `Hakija varasi tapaamisen: ${placeholders.eventStartTime}`,
        addRating: 'Lisäsi arvion',
        deleteRating: 'poisti arvionsa',
        withdrew: 'Hakija vetäytyi prosessista.',
        resetQuestionResponse: 'Poisti hakijan videovastauksen',
        joinedLiveInterview: 'Hakija liittyi haastatteluun',
        evaluated: 'arvioi hakijan',
      },
      videoLink: {
        linkText: 'Näytä sisältö',
      },
    },

    additionalFormFields: {
      title: 'Lomakkeen lisäkentät',
      description: context => (context === 'interview'
        ? 'Lisäkenttiä ei voi poistaa kutsujen lähettämisen jälkeen.'
        : 'Lisäkenttiä ei voi poistaa jos työpaikassa on hakijoita.'),
      add: 'Lisää uusi kenttä',
      addOption: 'Lisää',
      delete: 'Poista',
      done: 'Valmis',
      cancel: 'Peruuta',
      edit: 'Muokkaa',
      required: 'Pakollinen',
      optional: 'Valinnainen',
      notAsked: 'Ei kysytä',
      shortText: 'Lyhyt teksti',
      longText: 'Pitkä teksti',
      singleSelect: 'Valinta',
      multiSelect: 'Monivalinta',
      fieldLabelPlaceholder: 'Kentän otsikko hakijoille',
      fieldNamePlaceholder: 'Kentän nimi rekrytoijalle',
      addLabel: 'lisää otsikko',
      addName: 'lisää nimi',
      nameLabel: 'Kentän otsikko',
      typeLabel: 'Kentän tyyppi',
      optionLabel: 'Valintavaihtoehdot',
      settingsLabel: 'Lomakeasetukset',
      reorder: 'Järjestele kenttiä',
      stopReordering: 'Lopeta kenttien järjestäminen',
      optionPlaceholder: 'Lisää vaihtoehto',
      optionError: 'Vaihtoehto on jo lisätty',
    },

    addPublicQuestions: {
      title: 'Videokysymys',
      description: 'Tervehdi hakijoitasi ja lisää hakemusvaiheessa esitettävä videokysymys tässä.',
    },

    addQuestions: {
      edit: {
        start: 'Järjestele kysymyksiä',
        stop: 'Lopeta kysymyksien järjestäminen',
      },
      placeholder: isMobile => (isMobile ? 'Lataa tai nauhoita uusi kysymys' : 'Nauhoita uusi kysymys'),
      textQuestionPlaceholder: 'Kirjoita uusi kysymys',
      videoPlaceholder: isMobile => (isMobile ? 'Lataa tai nauhoita uusi video' : 'Nauhoita uusi video'),
      library: 'Valitse kirjastosta',
      text: 'Tekstikysymys',
      record: 'Nauhoita',
      upload: 'Lataa',
      answerable: 'Kysymykseen voi vastata',
      required: 'Vastaus on pakollinen',
      answerTimeLabel: 'Vastausaika',
      preparationTimeLabel: 'Valmistautumisaika',
      takeLimitLabel: 'Ottojen määrä',
      evaluationCriteriaLabel: 'Arviointikriteerit',
      questionPlaceholder: 'Kirjoita kysymyksesi tähän',
      evaluationCriteriaPlaceholder: 'Syötä kysymyksen arviointikriteerit tähän',
      cancel: 'Peruuta',
      add: 'Lisää',
      editOptions: 'Muokkaa',
      closeEdit: 'Sulje muokkaus',
      unlimitedLabel: 'Rajoittamaton',
    },

    addVideo: {
      title: 'Työnantajavideo',
      description: 'Tuo esille yrityskulttuuria ja paranna työnantajamielikuvaa lisäämällä työpaikkailmoitukseen työnantajavideo.',
    },

    adminCoverPhoto: {
      welcome: name => `Tervetuloa, ${name}!`,
      photo: 'Lisää taustakuva',
      removePhoto: 'Poista taustakuva',
    },

    adminFooter: {
      licenseLink:
        'https://www.recright.com/en/user-agreement/RecRight-license_agreement.pdf',
      privacyPolicyLink: 'https://get.recright.com/fi/tietosuojaseloste',
      termsLink:
        'https://get.recright.com/recright-terms-and-conditions-recruiter',
      accessibilityReportLink: 'https://websitemedia.recright.com/wp-content/uploads/2024/11/06112306/accessibility_report.pdf',
    },

    applicationFormSetup: {
      title: 'Hakemuslomakkeella pyydettävät tiedot',
      notAsked: 'Ei kysytä',
      optional: 'Valinnainen',
      required: 'Pakollinen',
      name: 'Nimi',
      coverLetter: 'Saatekirje',
      email: 'Sähköposti',
      phoneNumber: 'Puhelinnumero',
      city: 'Kaupunki',
      attachments: 'Liitteet',
      links: 'Linkit',
      questions: 'Videokysymys',
      attachmentsDescription: 'Kuvaus liitteille',
    },

    billingPlanSelector: {
      select: 'Valitse',
      removeSelection: 'Poista valinta',
      month: '/kuukausi',
      'recright-ats': 'Recright ATS',
      'recright-video-interview': 'Recright Videohaastattelut',
      'single-recruitment': 'Yksittäinen rekrytointi',
      'recright-essential': 'Recright Essential',
      'recright-pro': 'Recright Pro',
      'recright-premium': 'Recright Premium',
      'recright-easy': 'Easy',
      'recright-pro2': 'Pro',
      customPlan: 'Recright Räätälöity',
      plans: {
        'recright-easy': {
          info: '10 - 20 tehtävää/vuosi pienille ja keskisuurille yrityksille.',
          info2: 'Sisältää 10 tehtävää, mahdollisuus lisätä 5 tai 10 lisätehtävää.',
          features: [
            'Max 50 hakijaa/tehtävä',
            'Rajattomasti käyttäjiä',
            'Käyttäjien hallinta',
            'Tallennettu videoperehdytys työkaluun',
            'Brändäys',
            'Asiakastuki',
          ],
          unitType: '/kuukausi',
        },
        'recright-pro2': {
          info: 'Organisaatioille, jotka rekrytoivat säännöllisesti.',
          info2:
            'Sisältää kaikki samat ominaisuudet kuin yksittäisen tehtävän rekrytoinnissa, ja:',
          features: [
            '10 videorekrytointia vuodessa',
            'Max 50 hakijaa / videorekrytointi',
            'Rajoittamaton määrä käyttäjiä',
            'Käyttäjähallinta',
            'Asiakastuki',
            'Perusbrändäys',
            'Customer Success',
            'Tilastointi',
          ],
          unitType: '/kuukausi',
        },
        'recright-ats': {
          features: [
            'Rekrytointityökalu',
            'Rajattomasti avoimia työpaikkailmoituksia',
            'Työnantajamielikuvavideo',
            'Videokysymys hakemuslomakkeella',
            'Hakijoiden seulonta',
            'Hakijaviestintä',
            'Tiimin osallistaminen',
            'Hakijatietokanta',
          ],
          unitType: '/kuukausi',
        },
        'recright-video-interview': {
          features: [
            'Sisältää Recright ATS:n lisäksi',
            'Nauhoitetut videohaastattelut',
            'Usean videokysymyksen videohaastattelut',
            'Raportointityökalu',
            'Perehdytys',
            '15 rekrytointia vuodessa',
          ],
          unitType: '/kuukausi',

        },
        'recright-custom': {
          features: [
            'Volyymiperusteinen hinnoittelu',
            'Nimetty yhteyshenkilö',
            'Integraatio nykyiseen rekrytointijärjestelmään',
            'Live videohaastattelu',
          ],
          unitType: '/kuukausi',

        },
        'recright-essential': {
          features: [
            '15 tehtävää/vuosi',
            'Max 50 hakijaa/tehtävä',
            'Rajattomasti käyttäjiä',
            'Tallennettu videoperehdytys',
            'Perusbränding: logo & banneri',
          ],
          unitType: '/kuukausi',

        },
        'recright-pro': {
          features: [
            '30 tehtävää/vuosi',
            'Max 50 hakijaa/tehtävä',
            'Rajattomasti käyttäjiä',
            'Tallennettu videoperehdytys',
            'Parhaat käytännöt -koulutus',
            'Kattava brändäys: logo, banneri, värit & bannerit',
            'Hakijatyytyväisyyden mittaus',
            'Raportointi',
            'Nimetty yhteyshenkilö',
            'Käyttäjähallinta',
          ],
          unitType: '/kuukausi',

        },
        'recright-premium': {
          features: [
            'Yli 50 tehtävää/vuosi',
            'Rajattomasti käyttäjiä',
            'Parhaat käytännöt -koulutus',
            'Kattava brändäys: logo, banneri, värit & bannerit',
            'Hakijatyytyväisyyden mittaus',
            'Hakijatyytyväisyyden mittaus',
            'Raportointi',
            'Nimetty yhteyshenkilö',
            'Käyttäjähallinta',
            'Live-haastattelu',
            'Integraatio nykyiseen rekrytointijärjestelmään',
            'Active Directory -integraatio',
          ],
          unitType: '/kuukausi',

        },
        'single-recruitment': {
          info: 'Kätevä tapa kokeilla nauhoitettuja haastatteluja käytännössä',
          features: [
            'Sisältää kaikki työkalun ominaisuudet',
            'Yksi rekrytointi, johon sisältyy videohaastattelu ja työpaikkailmoitus',
            'voimassa 60 päivää \n\nilmoituksen tai videohaastattelun luomisesta',
          ],
          unitType: '/rekrytointi',

        },
      },
    },

    branding: {
      headerFont: 'Otsikon fontti',
      bodyFont: 'Leipätekstin fontti',
      backgroundColor: 'Taustaväri',
      textColor: 'Leipätekstin väri',
      brandColor: 'Brändiväri',
      buttonTextColor: 'Painikkeiden tekstin väri',
      headerTextColor: 'Otsikon tekstin väri',
    },

    candidateCard: {
      email: 'Sähköposti',
      noStatus: 'Ei statusta',
      lastSeen: time => `Viimeksi nähty ${time}.`,
      notVisited: 'Ei ole vielä käynyt haastattelusivulla.',
      createdAt: 'Luontiaika',
      lastAction: 'Viimeinen tapahtuma',
    },

    comments: {
      placeholder: 'Lisää uusi kommentti',
      submit: 'Lisää',
      delete: 'Poista',
      showComments: 'Näytä muiden kommentit',
      hideComments: 'Piilota muiden kommentit',
    },

    competencyList: {
      duplicateError: 'Tämän niminen ominaisuus on jo olemassa',
      defaultText: 'Jos et ole varma mitä ominaisuuksia käyttää, olemme määrittäneet muutaman oletusominaisuuden, joilla pääsee alkuun.',
      defaultLinkText: 'Hae oletusominaisuudet',
      addCompetency: 'Lisää ominaisuus',
    },

    chooseLicenseLink: {
      title: 'Valitse lisenssi',
    },

    currentFilters: {
      currentFilters: 'Rajaukset:',
    },

    emailForm: {
      emailLabel: 'Sähköposti',
      defaultButtonText: 'Lähetä',
    },

    filterToggler: {
      hideFilters: 'Piilota suodattimet',
      showFilters: 'Näytä suodattimet',
    },

    hashtags: {
      placeholder: 'Lisää luokittelu',
      delete: 'Poista',
    },

    imageInput: {
      errors: {
        format: 'Tiedosto ei ole kuvatiedosto.',
        size: 'Kuva on liian suuri, maksimikoko kuvatiedostolle on 4 Mt.',
      },
    },

    emailTemplateForm: {
      subjectPlaceholder: 'Otsikko',
      messagePlaceholder: 'Viesti',
      namePlaceholder: 'Nimi',
      namePlaceholder2:
        'Jos jätät nimen tyhjäksi, käytetään kutsuja lähettäessä käyttäjän allekirjoitusta tai nimeä.',
      templateNameLabel: 'Viestipohjan nimi',
      titleDisclaimer:
        '[INTERVIEW TITLE] korvataan haastattelun nimellä kutsuja lähetettäessä.',
      titleDisclaimerJob:
        '[JOB TITLE] korvataan työpaikan nimellä kun viesti lähetetään.',
      confirmLanguageChange:
        'Oletko varma että haluat vaihtaa kieltä? Kaikki tekemäsi tallentamattomat muutokset katoavat.',
      formatInfo:
        'Voit lisätä lihavoitua tekstiä, kursivoitua tekstiä tai linkkejä erityismuotoiluilla:',
      cursive: '_Kursivoitu_',
      bolded: '*Lihavoitu*',
      link: '[http://example.com|Linkin teksti]',
      greetingLabel: 'Tervehdys',
      greetingPlaceholder:
        'Tervehdys, joka näytetään viestin lopussa ennen allekirjoitusta.',
      greetingPlaceholder2: defaultGreeting =>
        `Jos jätät kentän tyhjäksi, käytetään kutsuja lähettäessä oletustervehdystä ${defaultGreeting}.`,
      getDefaultGreeting: 'Hae oletustervehdys',
    },

    liveEvaluation: {
      interviewTabLabel: 'Haastattelu',
      evaluationTabLabel: 'Arviointi',
      interviewNotesLabel: 'Haastattelumuistiinpanot',
      evaluationNotesLabel: 'Arviointimuistiinpanot',
      thankYouLabel: 'Kiitos!',
      evaluationSavedLabel: 'Olemme tallentaneet arviointisi hakijasta.',
      evaluatorLabel: 'Arvioija',
      evaluatorCount: count => (count === 1 ? '1 on arvioinut' : `${count} on arvioinut`),
      interviewersLabel: 'Haastattelijat',
      transcriptLoadingLabel: 'Transkriptia ladataan',
      recordingLabel: 'Haastattelun tallenne',
      evaluationNotesPlaceholder: stepTitle => `Osion ${stepTitle} muistiinpanot`,
      goToAILabel: 'Siirry AI-muistiinpanoihin',
      goBackLabel: 'Mene takaisin ylös',
      AISummaryLabel: 'AI-tiivistelmä',
      AINotesLabel: 'AI-muistiinpanot',
      AIInsightsLabel: 'AI-havainnot',
      aiAssistant: 'AI-avustaja',
      average: 'Keskiarvo',
      continueLaterLabel: 'Jatka myöhemmin',
      transcriptButtonText: 'Haastattelun transkripti',
      transcriptionError: 'Virhe transkriptia haettaessa',
      finishAndSubmitLabel: 'Viimeistele ja lähetä arviointi',
      averageForAllSections: 'Koko haastattelun keskiarvo',
      continueLaterText: title =>
        `Lähetimme sinulle sähköpostilla linkin, jotta voit jatkaa ehdokkaan arviointia haastattelussa ${title} myöhemmin.`,
      continueLaterNoTitleText:
        'Lähetimme sinulle sähköpostilla linkin, jotta voit jatkaa ehdokkaan arviointia haastattelussa myöhemmin.',
      closeEvaluation: 'Sulje',
      continueEvaluation: 'Jatka arviointia',
      confirmationTitle: 'Päätä arviointi?',
      confirmationMessage:
        'Oletko varma, että haluat päättää arvioinnin? Et voi tehdä lisämuutoksia tämän jälkeen.',
      previousStepButton: 'Siirry edelliseen',
      nextStepButton: 'Siirry seuraavaan',
      selectAtLeastOneEvaluator: 'Valitse vähintään yksi arvioija.',
      interviewInsights: 'Haastattelun havainnot',
    },

    interviewFormSetup: {
      title: 'Haastattelulomakkeella pyydettävät tiedot',
      notAsked: 'Ei kysytä',
      optional: 'Valinnainen',
      required: 'Pakollinen',
      name: 'Nimi',
      email: 'Sähköposti',
      phoneNumber: 'Puhelinnumero',
      city: 'Kaupunki',
      attachments: 'Liitteet',
      links: 'Linkit',
      attachmentsDescription: 'Kuvaus liitteille',
    },

    interviewRow: {
      invites: 'Kutsuja',
      responses: 'Vastauksia',
      endTime: 'Voimassa',
      createdAt: 'Luotu',
      timedTitle: 'Aikarajattu haastattelu',
      newVideos: 'Uusia vastauksia',
    },

    interviewGuideRow: {
      createdAt: 'Luontiaika',
      owner: 'Omistaja',
      language: 'Kieli',
    },

    interviewRoundRow: {
      createdAt: 'Luontiaika',
      owner: 'Omistaja',
      language: 'Kieli',
      endTime: 'Päättymisaika',
      status: 'Status',
    },

    interviewGuideStep: {
      noSteps: 'Osioita ei ole lisätty.',
      reorder: 'Järjestele osioita',
      titleLabel: 'Osion nimi',
      titlePlaceholder: 'Lisää osion nimi',
      interviewContentPlaceholder: 'Osion sisältö haastattelun aikana',
      evaluationContentPlaceholder: 'Osion sisältö haastattelun jälkeen',
      interviewTabLabel: 'Kysymykset',
      evaluationTabLabel: 'Arviointi',
      stepTimeLabel: 'Osion aika-arvio (min)',
      stopReordering: 'Lopeta osioiden järjestäminen',
      delete: 'Poista osio',
      add: 'Lisää uusi osio',
    },

    introduction: {
      batchIntroduction: count => `Esitelty ${count} vastaanottajalle`,
    },

    jobAdRow: {
      newApplications: 'Näkemättömät',
      applications: 'Hakemuksia',
      publishTime: 'Julkaisupäivä',
      endTime: 'Voimassa',
    },

    positionStatus: {
      open: date => (date ? `hakuaika päättyy ${date}` : ''),
      hidden: date => (date ? `hakuaika päättyy ${date}` : ''),
      filled: () => 'status: Täytetty',
      cancelled: () => 'status: Peruttu',
      closed: () => 'status: Suljettu',
      draft: () => 'status: Suljettu (luonnos)',
      unpublished: () => 'status: Luonnos',
      publishTime: 'Julkaisupäivä',
    },

    jobAdTeaser: {
      add: 'Lisää uusi hakija',
      noApplications: 'Ei vielä hakemuksia.',
      preview: 'Esikatsele työpaikkailmoitusta tästä',
      placeholder: {
        first: 'Voit markkinoida ilmoitustasi suoralla linkillä portaaliisi',
        second: 'tai voit markkinoida tätä kyseistä ilmoitusta osoitteella',
        third: 'Älä unohda, että kaikki nämä ovat yhden klikkauksen päässä otsikkopalkissa.',
      },
    },

    list: {
      total: count => `Yhteensä: ${count} hakijaa`,
      selectAll: 'Valitse kaikki',
      resetSelection: count => (count > 0 ? `Tyhjennä valinnat (${count})` : 'Tyhjennä valinnat'),
    },

    liveRow: {
      finished: 'Päättynyt',
      coming: 'Tulossa',
      active: 'Käynnissä',
      titleFallback: 'Live-haastattelu',
      startTime: 'Ajankohta',
      interviewers: 'Haastattelijat',
      candidates: 'Hakijat',
      status: 'Status',
    },

    loginForm: {
      email: 'Sähköpostiosoite',
      password: 'Salasana',
      submit: 'Kirjaudu palveluun',
      changePasswordInfo:
        'Salasana vaihdettu onnistuneesti. Kirjaudu sisään uudella salasanallasi.',
      error: {
        email: {
          isRequired: 'Täytä tähän sähköpostiosoitteesi.',
          isEmail: value => (value ? `Sähköpostiosoite ${value} ei ole kirjoitettu oikein.` : ''),
        },
        password: {
          isRequired: 'Täytä tähän salasanasi.',
        },
        login: {
          incorrect: 'Kirjautuminen epäonnistui.',
          deactivated:
            'Käyttäjätili on poistettu käytöstä. Ota yhteyttä organisaatiosi Recright järjestelmävalvojaan.',
          tries: 'Turvallisuutesi varmistamiseksi rajoitamme uudelleenyritysten määrää. Kokeile hetken päästä uudelleen tai vaihda salasanasi.',
        },
      },
    },

    logoUpload: {
      logoTitle: 'Organisaation logo tähän',
      removeLogo: 'Poista logo',
      addLogo: 'Valitse logo',
    },

    modalAccountType: {
      title: 'Vaihda tilin tyyppiä?',
      confirm: 'Vaihda',
      cancel: 'Peruuta',
    },

    modalApplicationAllInvited: {
      title: 'Kutsu hakijoita',
      description: 'Kaikki valitut hakijat on jo kutsuttu haastatteluun.',
    },

    modalApplicationIntroduce: {
      title: 'Esittele hakijoita',
      description: 'Lisää alle esittelyjen vastaanottajien sähköpostiosoitteet',
      titlePlaceholder: 'Otsikko',
      contentPlaceholder: 'Esittelyviestin sisältö',
      emailsPlaceholder: 'Sähköpostiosoitteet',
      namePlaceholder: 'Nimi',
      cancel: 'Peruuta',
      sendIntroductions: 'Lähetä esittelyt',
    },

    modalApplicationInvite: {
      title: 'Kutsu hakija seuraavaan vaiheeseen',
      description: 'Jatka rekrytointiprosessia valittujen hakijoiden kanssa ja valitse toiminto alta.',
      createNew: 'Luo uusi haastattelu',
      videoInterviewDescription: 'Kutsu hakija videohaastatteluun, ja näe persoona hakemuksen takana!',
      error: {
        selectInterview: 'Ole hyvä ja valitse haastattelu',
      },
      cancel: 'Peruuta',
      close: 'Sulje',
      continue: 'Jatka',
    },

    modalApplicationReInvite: {
      title: 'Lähetä kutsu uudelleen',
      description: 'Valitse haastattelu, johon haluat kutsua hakijan uudelleen.',
      info: 'Et voi lähettää kutsua haastatteluun, joka on suljettu.',
      cancel: 'Peruuta',
      submit: 'Lähetä kutsu uudelleen',
    },

    modalApplicationMessage: {
      title: 'Lähetä viesti valituille hakijoille',
      description: 'Minkälaisen viestin haluat lähettää?',
      email: 'Lähetä sähköposti',
      videoMessage: 'Lähetä videoviesti',
      close: 'Sulje',
      cancel: 'Peruuta',
      continue: 'Jatka',
      sendEmail: 'Lähetä viesti',
      emailTitle: 'Lähetä sähköposti kandidaateille',
      emailDescription: 'Kirjoita viesti valituille hakijoille',
      videoTitle: 'Lisää uusi video',
      titlePlaceholder: 'Otsikko',
      contentPlaceholder: 'Kirjoita viestisi tähän',
      candidates: 'hakijaa',
      selectedCandidates: 'Vastaanottajat',
      emailSent: 'Sähköposti lähetetty!',
      answerable: 'Videoon voi vastata',
      signature: 'Ystävällisin terveisin',
    },

    modalAtsTeaser: {
      title: 'Julkaise avoimia työpaikkoja sekä hallinnoi rekrytointia',
      content: 'Recright mahdollistaa avoimen työpaikkasivuston sekä rekrytoinnin hallinnan yhdestä samasta työkalusta. Tehosta hakijaviestintääsi ottamalla hakemukset vastaan avoimen työpaikkasivun kautta suoraan rekrytointityökaluun ja kommunikoimalla tätä kautta hakijoiden kautta.',
      cancel: 'Ei vielä, sulje',
      confirm: 'Kyllä, olkaa minuun yhteydessä!',
      greetings: 'Viesti lähetetty onnistuneesti.',
    },

    modalFeedbackPulseTeaser: {
      title: 'Haluatko tietää miten ehdokkaasi arvioivat rekrytointiprosessin?',
      content: 'Ehdokkaasi voivat arvioida kokemuksensa hakuprosessinsa päätyttyä. Hakijapulssin avulla näet ehdokkaiden hakijakokemuksen keskiarvon.',
      cancel: 'Peruuta',
      confirm: 'Kyllä, olkaa minuun yhteydessä!',
      greetings: 'Viesti lähetetty onnistuneesti.',
    },

    modalCandidateMessage: {
      title: count => (count > 1 ? 'Lähetä viesti valituille hakijoille' : 'Lähetä viesti hakijalle'),
      description: 'Millaisen viestin haluat lähettää?',
      recipients: count => `Viesti lähetetään ${count} vastaanottajalle.`,
      email: 'Lähetä sähköposti',
      videoMessage: 'Lähetä videoviesti',
      library: 'Valitse kirjastosta',
      close: 'Sulje',
      cancel: 'Peruuta',
      continue: 'Jatka',
      sendEmail: 'Lähetä viesti',
      resendInvitation: 'Lähetä kutsu uudelleen',
      resendInvitationSms: 'Lähetä kutsu uudelleen tekstiviestillä',
      emailTitle: count => (count > 1 ? 'Lähetä sähköposti hakijoille' : 'Lähetä sähköposti hakijalle'),
      emailDescription: 'Kirjoita viesti valituille hakijoille',
      videoTitle: 'Lisää uusi video',
      libraryTitle: count => (count > 1 ? 'Lähetä video hakijoille' : 'Lähetä video hakijalle'),
      titlePlaceholder: 'Otsikko',
      contentPlaceholder: 'Kirjoita viestisi tähän',
      candidates: 'hakijaa',
      selectedCandidates: 'Vastaanottajat',
      emailSent: candidates => `${candidates} sähköposti(a) lähetetty!`,
      answerable: 'Videoon voi vastata',
      successMessage: candidates => `${candidates} videoviestiä lähetetty!`,
      sms: 'Lähetä tekstiviesti',
      scheduledInterview: 'Lähetä kutsu tapaamiseen',
      scheduledInterviewDescription: 'Kutsu hakija henkilökohtaiseen haastatteluun ja pyydä valitsemaan sopiva vaihtoehto vapaana olevista ajoista.',
      reScheduledInterview: 'Sovi tapaaminen uudelleen',
      record: 'Nauhoita',
      upload: 'Lataa',
      required: '* Tähdellä merkityt kentät ovat pakollisia.',
      reScheduledInterviewDescription: 'Uudelleenkutsu hakija henkilökohtaiseen haastatteluun. Otathan huomioon, että aikasemmat kutsut peruutetaan',
      tooManyRecipients: count => `Liian monta vastaanottajaa valittu. Enimmäismäärä on ${count}.`,
      tooLongMessage:
        'Liian pitkä viesti. Tarkista viestimerkkilaskuri. Jotkin erikoismerkit lyhentävät viestin maksimipituutta.',
    },

    modalEditIntroduceBatches: {
      title: 'Esittelyt',
      description: 'Täällä voit hallita tehtävän esittelyjä. Voit jatkaa esittelyjen vastaanottajien esittelylinkkien voimassaoloaikaa, Poistaa henkilöitä esittelyryhmästä tai poistaa koko esittelyryhmän.',
      noBatches: 'Ei esittelyjä.',
      descriptionWithCount: (candidateNames) => `Esitelty ${candidateNames} ja %COUNT_LINK% muuta seuraaville henkilöille:`,
      descriptionWithoutCount: candidateNames => `Esitelty ${candidateNames} seuraaville henkilöille:`,
      email: 'Sähköposti',
      expires: 'Voimassa',
      actions: 'Toiminnot',
      visited: 'Vieraillut',
      extendLinkText: 'Jatka',
      extendTo: date => `Jatka ${date} asti`,
      close: 'Sulje',
      deleteBatch: 'Poista esittelyryhmä',
      deleteBatchWarning: 'Haluatko varmasti poistaa esittelyryhmän?',
      maxExpirationDate: 'Linkin voimassaolopäivä on maksimissaan 10 päivän päässä tästä päivästä.',
      extendedMessage: newExpirationDate => `Esittelylinkin voimassaoloa jatkettu ${newExpirationDate} asti!`,
      url: 'URL',
      introductionLink: 'Linkki',
    },

    modalEditEmailSettings: {
      customReplyToTitle: 'Kutsuviestin lähettäjän tiedot',
      customReplyToSubtitle:
        'Kutsuviestin lähettäjän nimi ja vastausosoite. Jos jätät kentät tyhjiksi, käytetään kutsujen lähettävän käyttäjän nimeä ja sähköpostia.',
      customReplyToEmail: 'Vastaussähköposti kutsuviesteille',
      customReplyToName: 'Lähettäjän nimi kutsuviestissä',
      saveSuccess: 'Muutokset tallennettu onnistuneesti.',
    },

    modalEditInvitationMessage: {
      title: 'Muokkaa haastatteluun tallennettua kutsuviestiä',
      info: 'Valitse haastattelu, jota haluat muokata',
      secret: 'salainen-tunniste',
      close: 'Sulje',
      saveTemplate: 'Tallenna haastattelun viestipohjaksi',
      templateSaved: 'Viesti tallennettiin haastattelun viestipohjaksi.',
      templateOptionsLabel: 'Valitse viestipohja',
      interviewRound: {
        title: 'Muokkaa haastattelukierroksen kutsuviestiä',
        submitButtonText: 'Tallenna haastattelukierroksen kutsuviestipohja',
        templateSaved: 'Viesti tallennettiin haastattelukierroksen kutsuviestipohjaksi.',
      },
    },

    modalEditStages: {
      title: 'Muokkaa rekrytointivaiheita',
      info: 'Voit muokata, lisätä, poistaa ja järjestellä rekrytointivaiheita. Huomaa, että vaiheen poistaminen ei ole mahdollista jos vaiheessa on hakijoita.',
      addNewStage: 'Lisää uusi rekrytointivaihe',
      removeDisabled: 'Vaiheen poistaminen ei ole mahdollista, kun vaiheessa on hakijoita.',
      error: 'Vaihe on jo lisätty.',
      done: 'Valmis',
      save: 'Tallenna',
      close: 'Sulje',
      confirm: 'Vahvista',
      cancel: 'Peruuta',
      delete: 'Poista',
    },

    modalHidePositionsFromUser: {
      modalHeader: 'Piilotetut positiot',
      modalDescription: name => `Valise positiot, jotka haluat piilottaa käyttäjältä ${name}.`,
      hiddenFrom: name => `Käyttäjältä ${name} piilotetut positiot`,
      noResults: 'Ei tuloksia',
      noPositions: 'Ei positioita',
      jobAdLabel: 'Työpaikkailmoitus',
      interviewLabel: 'Videohaastattelu',
      total: total => `yhteensä ${total} positiota`,
      close: 'Sulje',
      hide: 'Piilota',
      remove: 'Poista',
      searchInfo: 'Selaa piilotettavia positioita',
      searchPlaceholder: 'Etsi positioita nimellä tai sijainnilla',
      labels: {
        title: 'Nimi',
        location: 'Sijainti',
        time: 'Luotu',
        actions: 'Toiminnot',
      },
    },

    modalRemoveUserFromOrganisation: {
      modalHeader: 'Käyttäjän poistaminen organisaatiosta',
      modalDescription: name =>
        `Käyttäjä ${name} on ulkoinen käyttäjä ja poistetaan vain tästä organisaatiosta. Poistamisen jälkeen käyttäjä säilyttää pääsyn muihin käyttäjän organisaatioihin Recrightissa.`,
      modalExplanation: name =>
        `Näin ollen, käyttäjällä ei ole enää pääsyä tämän organisaation avoimiin positioihin. Omistajuus positioihin joissa ${name} oli ainoa rekrytoija siirretään sinulle.`,
      adminInRecruitmentTeam: name =>
        `Positiot joissa käyttäjä ${name} oli osa rekrytointitiimiä:`,
      noResults: 'Ei tuloksia',
      noPositions: 'Ei positioita',
      jobAdLabel: 'Työpaikkailmoitus',
      interviewLabel: 'Videohaastattelu',
      total: total => `yhteensä ${total} positiota`,
      close: 'Sulje',
      remove: 'Poista organisaatiosta',
      removeUserConfirmMessage: 'Poista käyttäjä',
      removeUserConfirmContent:
        'Oletko varma että haluat poistaa käyttäjän tästä organisaatiosta?',
      labels: {
        title: 'Nimi',
        time: 'Luotu',
        creator: 'Position uusi omistaja',
      },
      otherAdmin: 'Muu rekrytointitiimin jäsen',
    },

    modalInterviewRoundSelectInviteType: {
      title: 'Valitse aikataulutustyyppi',
      subtitle:
        'Valitse, päättääkö rekrytoija haastattelun ajankohdan, vai valitseeko hakija sen tarjolla olevista ajoista.',
      regularTitle: 'Tavallinen',
      regularDescription: 'Rekrytoija valitsee haastattelun ajankohdan.',
      scheduledTitle: 'Aikataulutettu',
      scheduledDescription: 'Hakija valitsee haastattelun ajankohdan.',
      cancel: 'Peruuta',
      continue: 'Jatka',
    },

    modalInterviewRoundInvite: {
      nameEmailLabel: 'Nimi/Sähköposti',
      startTimeLabel: 'Haastattelun aloitusaika*',
      title: 'Aikatauluta haastattelu',
      selectedCandidates: 'Valitut hakijat',
      submit: 'Lähetä kutsut',
      savedTemplate: 'Tallennettu viestipohja',
      templateChangedInfo:
        'Olet muokannut kutsuviestiä. Tämä muutos lähetetään valitsemillesi vastaanottajille, mutta sitä ei tallenneta haastattelukierroksen viestipohjaan.',
      saveTemplate: 'Tallenna haastattelukierroksen viestipohjaksi',
      templateSaved:
        'Viesti tallennettiin haastattelukierroksen viestipohjaksi.',
    },

    interviewRoundInviteModalContent: {
      subjectPlaceholder: 'Otsikko',
      messagePlaceholder: 'Viesti',
      namePlaceholder: 'Nimi',
    },

    modalReschedule: {
      title: 'Päivitä haastattelun ajankohta',
      submit: 'Lähetä viesti',
      rescheduleConfirmBody: 'Oletko varma että haluat muuttaa haastattelun ajankohdan?',

    },

    modalPersonStage: {
      new: 'Uusi',
      hired: 'Palkattu',
      proceed: 'Käsittelyssä',
      personalinterview: 'Henkilökohtainen haastattelu',
      withdrawn: 'Vetäytynyt prosessista',
      scheduledinterview: 'Sovittu tapaaminen',
      rejected: 'Hylätty',
      videointerviewed: 'Videohaastattelu',
      change: 'Siirrä hakijat vaiheesta toiseen',
      info: 'Siirrä valitut hakijat toiseen vaiheeseen. Tämä tieto ei näy hakijoille.',
      done: 'Siirrä',
      cancel: 'Peruuta',
      changed: 'Loistavaa!',
      reopenProcessConfirmPlural: 'Oletko varma, että haluat siirtää hakijat pois vaiheesta “Vetäytynyt prosessista” ja palauttaa heidät takaisin rekrytointiprosessiin? Tämän jälkeen hakijat pääsevät taas vastaamaan haastatteluun, jos siihen vastaaminen on heillä kesken.',
      withdrawConfirmPlural: 'Oletko varma, että haluat poistaa hakijat rekrytointiprosessista ja siirtää heidät vaiheeseen “Vetäytynyt prosessista”? Tämän jälkeen hakijat eivät enää pääse vastamaan haastatteluun.',
      changedInfo: stage => `Nyt kun olet siirtänyt hakijat vaiheeseen "${stage}", ilmoita heille siitä! \n\n Lähetä heille sähköpostia tai videoviesti.`,
      close: 'Sulje',
      changeSingle: 'Siirrä hakija vaiheesta toiseen',
      infoSingle: 'Siirrä hakija toiseen vaiheeseen. Tämä tieto ei näy hakijalle.',
      changedInfoSingle: stage => `Nyt kun olet siirtänyt hakijan vaiheeseen "${stage}", ilmoita heille siitä! \n\n Lähetä heille sähköpostia tai videoviesti.`,
    },

    modalInterviewAdd: {
      title: 'Luo uusi videohaastattelu',
      description: 'Valitse minkä tyyppisen haastattelun haluat luoda.',
      friendlyTitle: 'Videohaastattelu',
      friendlyDescription: 'Hakijat voivat vastatessaan ottaa niin monta ottoa kuin haluavat ilman aikarajoituksia.',
      timedTitle: 'Aikarajattu videohaastattelu',
      timedDescription: 'Hakijat vastaavat haastattelukysymyksiin rajoitetun ajan sisällä. Voit asettaa sekä vastausajan että valmistautumisajan jokaiselle kysymykselle erikseen.',
      cancel: 'Peruuta',
      continue: 'Jatka',
    },

    modalLiveInterviewAdd: {
      title: 'Luo uusi live-haastattelu',
      description: 'Valitse minkä tyyppisen live-haastattelun haluat luoda.',
      basicTitle: 'Live-haastattelu',
      basicDescription: 'Päätät itse haastattelun ajankohdan.',
      scheduledTitle: 'Aikataulutettu live-haastattelu',
      scheduledDescription:
        'Hakija valitsee itselleen sopivan haastatteluajan vapaista ajankohdista.',
      cancel: 'Peruuta',
      continue: 'Jatka',
    },

    modalInterviewPublish: {
      modalTitle: 'Julkaisuasetukset',
      publicTitle: 'Julkinen haastattelu',
      publicDescription: 'Sähköpostikutsujen lisäksi voit julkaista haastattelusi avoimena. Kaikki tehtävästä kiinnostuneet voivat nähdä avoimen haastattelun kysymykset ja päättää itse vastata. Avoimella haastattelulla on julkinen sivu, jonka osoitetta voit jakaa vaikka työpaikkailmoituksissa. Voit julkaista ja sulkea avoimen haastattelusivun koska tahansa.',
      publishButton: 'Luo julkinen osoite',
      unPublishButton: 'Poista julkinen osoite',
      title: 'Upotettu haastattelu',
      description: 'Voit upottaa yhden kysymyksen videohaastattelun työpaikkailmoitukseen tai yrityksesi sivustolle. Hakija antaa sähköpostiosoitteensa, vastaa yhdellä videovastauksella, sekä voi antaa lisätietona linkin esim. LinkedIn -profiiliinsa.',
      descriptionMultiple:
        'Voit upottaa haastattelun työpaikkailmoitukseen tai yrityksesi sivustolle. Hakija antaa sähköpostiosoitteensa, vastaa kysymyksiin videovastauksilla, sekä voi antaa lisätietona linkin esim. LinkedIn -profiiliinsa.',
      embedNotification: 'Upotetulla haatattelulla ei voi kysyä muita tietoja.',
      embedButton: 'Luo upotus',
      unEmbedButton: 'Poista upotus',
      close: 'Sulje',
      oneError: 'Upotetussa haastattelussa voi olla vain yksi kysymys. Poista muut kysymykset käyttääksesi upotettua haastattelua.',
      subscriptionNeeded: 'Tarvitset voimassa olevan tilauksen julkaistaksesi videohaastattelun.',
    },

    modalIntroduce: {
      title: count => (count > 1 ? 'Esittele hakijoita' : 'Esittele hakija'),
      descriptionFirst: 'Esittelytoiminnolla voit esitellä valittuja hakijoita esimerkiksi esimiehelle.',
      descriptionSecond: 'Lisää alle esittelyjen vastaanottajien sähköpostiosoitteet. Valitse mitä tietoja haluat vastaanottajien näkevän hakijalta. Esittelyjen vastaanottajat näkevät vain valitut tiedot. Jos valitset "Arvosana" tai "Osaaminen ja ominaisuudet", esittelyn vastaanottaja pystyy antamaan oman arvionsa ja näkee myös annettujen arvosanojen keskiarvon.',
      descriptionThird: 'Sinulla on myös mahdollisuus suojata esittelyryhmä pääsykoodilla, jota esittelyjen vastaanottajilta kysytään kun he haluavat päästä näkemään esitellyt hakijat.',
      descriptionFourth: days =>
        `Esittely on voimassa ${days} vuorokautta esittelyn lähettämisestä. Voit jatkaa voimassaoloaikaa esittelyiden hallintasivulta, johon pääset "Muokkaa"-valikosta.`,
      titlePlaceholder: 'Otsikko',
      contentPlaceholder: 'Esittelyviestin sisältö',
      emailsPlaceholder: 'Sähköpostiosoitteet',
      namePlaceholder: 'Nimi',
      cancel: 'Peruuta',
      sendIntroductions: 'Lähetä esittelyt',
      selectedCandidates: count => `${count} esittelyyn valittua hakijaa`,
      successMessage: (candidates, introducees) => `${candidates} hakijaa esitelty ${introducees} henkilölle`,
      infoMessage: (candidates, introducees, isInTeam) => `${candidates} hakijaa esitelty ${introducees} henkilölle. ${isInTeam} kuului jo rekrytointitiimiin`,
      alreadyInTeam: inTeam => (inTeam > 1 ? 'kuuluvat jo rekrytointitiimiin.' : 'kuuluu jo rekrytointitiimiin.'),
      name: 'Nimi',
      email: 'Sähköposti',
      phone: 'Puhelinnumero',
      city: 'Kaupunki',
      coverLetter: 'Saatekirje',
      attachments: 'Liitteet',
      links: 'Linkit',
      competencies: 'Osaaminen ja ominaisuudet',
      videoResponses: 'Videovastaukset',
      comments: 'Kommentit',
      rating: 'Arvosana',
      informationsHeader: 'Valitse mitä tietoja esitellään',
      messageHeader: 'Esittelyviesti',
      selectAll: 'Valitse kaikki',
      resetSelection: 'Tyhjennä valinnat',
      usePasscodeText: 'Suojaa esittelyryhmä pääsykoodilla',
      passcode: 'Pääsykoodi',
      generatePasscode: 'Luo uusi koodi',
      copyToClipboard: 'Kopioi leikepöydälle',
      copySuccess: 'Koodi kopioitu!',
      close: 'Sulje',
      introduceLinkButton: 'Luo linkki',
      introduceLink: 'Esittele linkillä',
      introduce: 'Esittele',
      formError: 'Virhe',
      linkCreationError: 'Virhe luodessa esittelylinkkiä.',
      link: 'Linkki',
      aiInsights: 'AI-havainnot',
      transcripts: 'Transkriptit',
      continue: 'Jatka',
    },

    modalInterviewInvite: {
      senderInfo: 'Kutsut lähetetään invitations@recright.com -osoitteesta.',
      replyToEmail: 'Vastaussähköposti kutsuviesteille',
      replyToName: 'Lähettäjän nimi kutsuviestissä',
      replyToInfo: 'Voit muokata näitä kenttiä haastattelun muokkaussivulla.',
      notAnswerable: 'Et voi kutsua hakijoita haastatteluun joka on suljettu tai ei sisällä vastattavia kysymyksiä.',
      title: 'Kutsu hakijoita',
      description: 'Syötä kaikkien hakijoiden sähköpostiosoitteet',
      description2: ' Kun he lähettävät vastauksensa, saat ilmoituksen sähköpostiisi. Huomioithan, että kun olet kutsunut hakijat, et voi enää lisätä kysymyksiä haastatteluun.',
      smsDescription: 'Voit lähettää hakijalle kutsun myös tekstiviestillä sähköpostikutsun lähettämisen jälkeen',
      addressesPlaceholder: 'Hakijoiden sähköpostiosoitteet',
      secret: 'salainen-tunniste',
      submit: 'Lähetä kutsut',
      cancel: 'Peruuta',
      close: 'Sulje',
      inviteInfo: (newInvitees, stage) => `Haastattelukutsu lähetetään ${newInvitees} hakijalle valitusta hakijoista. Kaikki valitut hakijat siirretään vaiheeseen "${stage}".`,
      templateChangedInfo: 'Olet muokannut kutsuviestiä. Tämä muutos lähetetään valitsemillesi vastaanottajille, mutta sitä ei tallenneta haastattelun viestipohjaan.',
      saveTemplate: 'Tallenna haastattelun viestipohjaksi',
      templateSaved: 'Viesti tallennettiin tämän haastattelun viestipohjaksi.',
      invitesSent: (success, failed) => (failed > 0 ? `${success} kutsua lähetettiin ja ${failed} oli jo kutsuttu.` : `${success} kutsua lähetettiin.`),
      subscriptionNeeded: 'Tarvitset voimassa olevan tilauksen kutsuaksesi hakijoita videohaastatteluun.',
      templateOptionsLabel: 'Valitse viestipohja',
      rrTemplateOptionLabel: 'Recrightin oletusviestipohja',
      interviewTemplateOptionLabel: 'Haastatteluun tallennettu viestipohja',
      interviewRoundTemplateOptionLabel: 'Haastattelukierroksen tallennettu viestipohja',
    },

    modalInterviewInviteSms: {
      title: 'Kutsut lähetetty onnistuneesti',
      description: count => `${count} kutsua lähetetty onnistuneesti`,
      description2: 'Haluatko lähettää kutsun hakijoille myös tekstiviestillä?',
    },

    modalSmsMessage: {
      title: 'Tekstiviestin lähetys',
      invitationTitle: 'Lähetä kutsu tekstiviestillä',
      resendInvitationTitle: 'Lähetä kutsu uudelleen tekstiviestillä',
      description: count => `Kutsu lähetetään  ${count} vastaanottajalle`,
      missingInvitationDescription: count => `${count} vastaanottajalta puuttuu kutsuviesti. Kirjoita kutsuviesti alle.`,
      missingPhone: count => `${count} vastaanottajalta puuttuu puhelinnumero.`,
      missingPhone2: 'Syötä puhelinnumerot alla oleviin kenttiin.',
      successMessage: count => `${count} tekstiviestiä lähetetty onnistuneesti.`,
      partialSuccessMessage: (successCount, failedCount) => `${successCount} tekstiviestiä lähetetty onnistuneesti. ${failedCount} tekstiviestiä ei voitu lähettää.`,
      failedMessage: 'Tekstiviestiä ei voitu lähettää yhdellekään vastaanottajalle.',
      phonePlaceholder: 'Puhelinnumero',
      recipientsNotFound: 'Tapahtui odottamaton virhe. Yritä myöhemmin uudelleen. Jos ongelma ei katoa, olethan yhteydessä tukeemme.',
    },

    modalInterviewStatus: {
      change: 'Vaihda haastattelun status',
      changed: 'Haastattelun status vaihdettu',
      changeRoundStatus: 'Vaihda haastattelukierroksen status',
      roundStatusChanged: 'Interview round status changed',
      changedInfo: 'Haastattelun status vaihdettu. Muistathan ilmoittaa hakijoille päätöksistä!',
      info: 'Valitse haastattelun uusi status.',
      open: 'Avoin',
      closed: 'Suljettu',
      done: 'Valmis',
      close: 'Sulje',
      endTimeInPast: model => model === 'interview' ?
        'Haastattelulla on päättymispäivä, joka on menneisyydessä. Kun avaat haastattelun, päättymispäivä poistetaan. voit asettaa uuden päättymispäivän ' :
        'Haastattelukierroksella on päättymispäivä, joka on menneisyydessä. Kun avaat haastattelukierroksen, päättymispäivä poistetaan. Voit asettaa uuden päättymispäivän ',
      endTimeInPastLink: 'haastattelun muokkaussivulta',
      cancel: 'Peruuta',
    },

    modalInterviewSelectForEdit: {
      title: 'Muokkaa haastattelua',
      info: 'Valitse haastattelu, jota haluat muokata.',
      cancel: 'Peruuta',
      done: 'Valmis',
      error: {
        selectInterview: 'Ole hyvä ja valitse haastattelu',
      },
    },

    modalJobAdPreview: {
      title: 'Työpaikkailmoituksen esikatselu',
      description: 'Näet tästä miltä työpaikkailmoitus näyttää hakijalle.',
      description2: 'Huomaa, että esikatselussa käytetty kieli ei ole ilmoitukselle asetettu kieli.',
      close: 'Sulje',
      back: 'Takaisin',
    },

    modalJobAdStatus: {
      change: 'Vaihda työpaikan status',
      changed: 'Työpaikan status vaihdettu',
      changedInfo: 'Työpaikan status vaihdettu. Muistathan ilmoittaa hakijoille päätöksistä!',
      info: 'Valitse työpaikan uusi status. Jos valitset “Täytetty” tai “Peruttu” sinut ohjataan valitsemaan palkatut henkilöt ja/tai lähettämään lopuille “Ei kiitos”-viestit',
      open: 'Avoin',
      filled: 'Täytetty',
      cancelled: 'Peruttu',
      done: 'Valmis',
      close: 'Sulje',
      draft: 'Suljettu (luonnos)',
      closed: 'Suljettu',
      unpublished: 'Luonnos',
      hidden: 'Piilotettu',
      openDescription: 'Työpaikan hakuaika päättyy',
      filledDescription: 'Sulje ilmoitus, koska työpaikka on täytetty',
      cancelledDescription: 'Sulje ilmoitus, koska rekrytointiprosessi on peruttu',
      closedDescription: 'Ilmoitus on suljettu. Ilmoitus ei ole saatavilla tai näkyvillä hakijoille',
      hiddenDescription: 'Piilota ilmoitus uraosiosta. Ilmoitus on saatavilla vain suoralla linkillä:',
      unpublishedDescription: 'Ilmoitusta ei ole julkaistu. Ilmoitus ei ole saatavilla tai näkyvillä hakijoille.',
      cancel: 'Peruuta',
    },

    modalJobPositionTeam: {
      addAnother: 'Lisää käyttäjiä syöttämällä heidän sähköpostiosoitteensa',
      team: 'Rekrytointitiimi',
      info: 'Voit lisätä kollegoita ja muita käyttäjiä arvioimaan tähän työpaikkaan liittyviä hakijoita',
      newMembersMsg: 'Uudet rekrytointitiimin jäsenet, joilla ei ole Recright-tiliä, lisätään organisatioon, johon tämä työpaikka kuuluu.* Jos käyttäjän sähköpostiosoitteen verkkotunnus ei vastaa organisaatioon liitettyä verkkotunnusta, uusi käyttäjä saa pienimmät mahdolliset käyttöoikeudet. Ylläpitäjät, joilla on pääsy käyttäjien hallintaan, voivat muuttaa käyttöoikeuksia myöhemmin.',
      asteriskSymbol: '*',
      currentTeam: 'Nykyinen tiimi',
      done: 'Valmis',
      remove: 'Poista',
      submit: 'Lisää jäseniä tiimiin',
      cancel: 'Peruuta',
      selfRemovedMessage: 'Olet poistanut itsesi rekrytointitiimistä.',
      successMessage: count => `${count} jäsentä lisätty rekrytointitiimiin.`,
      errors: {
        duplicate: 'Sähköposti on jo lisätty.',
        duplicateMultiple: 'Yhdellä tai useammalla syötetyllä sähköpostiosoitteella löytyi jo käyttäjä rekrytointitiimistä.',
        isEmail: 'Sähköpostiosoite on virheellinen.',
        isEmailMultiple: 'Joukossa oli virheellisiä sähköpostiosoitteita.',
        isRequired: 'Kenttä on tyhjä.',
      },
    },

    modalJobPositionCopy: {
      title: (context, position) => `Haluatko varmasti tehdä kopion ${context === 'jobAd' ? 'työpaikasta' : 'haastattelusta'} "${position.title}"?`,
      admins: 'Haluatko kopioida myös rekrytointitiimin?',
      done: 'Kopioi',
      cancel: 'Peruuta',
    },

    modalVideos: {
      title: 'Videokirjastosi',
      yourVideos: 'Omat videosi',
      companyVideos: 'Organisaation videot',
      add: 'Lisää video',
      done: 'Lisää videot',
      cancel: 'Peruuta',
      selectedVideos: 'Valitut videot',
      clearAll: 'Tyhjennä kaikki',
    },

    videoCollectionBrowser: {
      allVideos: 'Kaikki videot',
      noCollections: 'Ei kokoelmia',
      videoCountSingular: 'video',
      videoCountPlural: 'videota',
      folderView: 'Kansionäkymä',
      listView: 'Listanäkymä',
      sort: {
        createdAt: 'Luontiaika',
        title: 'Otsikko',
      },
    },

    modalUsersAdd: {
      title: 'Kutsu käyttäjiä',
      languageDescription: 'Käyttäjien oletuskieli:',
      permissionsDescription: 'Näillä käyttäjillä on seuraavat oikeudet:',
      emailsPlaceholder: 'Syötä käyttäjien sähköpostiosoitteet',
      seeAllPositions: 'Näe kaikki positiot',
      createJobPositions: 'Työpaikkojen luonti',
      createInterviews: 'Haastatteluiden luonti',
      account: 'Yritysprofiilin muokkaus',
      billing: 'Laskutus',
      reporting: 'Raportointi',
      editUsers: 'Käyttäjähallinta',
      default: 'Oletusoikeudet',
      cancel: 'Peruuta',
      submit: 'Kutsu käyttäjiä',
    },

    modalCompanyDefaultPermissionsEdit: {
      title: 'Oletusoikeudet:',
      description: 'Uudet käyttäjät, jotka rekisteröityvät tähän organisaatioon saavat oletuksena nämä oikeudet.',
      seeAllPositions: 'Näe kaikki positiot',
      createJobPositions: 'Työpaikkojen luonti',
      createInterviews: 'Haastatteluiden luonti',
      account: 'Yritysprofiilin muokkaus',
      billing: 'Laskutus',
      reporting: 'Raportointi',
      editUsers: 'Käyttäjähallinta',
      cancel: 'Peruuta',
      submit: 'Tallenna',
    },

    modalOtherApplications: {
      title: 'Hakija muissa positioissa',
      header: 'Tässä lista hakijasta muissa positioissa',
      close: 'Sulje',
    },

    getPermissionsLabels: {
      permissions: {
        seeAllPositions: 'Näe kaikki positiot',
        createJobPositions: 'Työpaikkojen luonti',
        createInterviews: 'Haastatteluiden luonti',
        account: 'Yritysprofiilin muokkaus',
        billing: 'Laskutus',
        reporting: 'Raportointi',
        editUsers: 'Käyttäjähallinta',
        default: 'Oletusoikeudet',
      },
    },
    modalCronofy: {
      linkCalendar: {
        title: 'Kalenterin yhdistäminen',
        description: 'Tapaamisten sopiminen voi olla stressaavaa, mutta sen ei tarvitse olla! Anna hakijoiden valita heille sopiva aika suoraan Recright-työkalusta. Aloita toiminnallisuuden hyödyntäminen yhdistämällä kalenteri Recrightiin.',
        authorize: 'Yhdistä kalenterisi täältä',
        authorized: profileName => `Olet onnistuneesti yhdistänyt kalenterisi ${profileName} Recrightiin! Voit poistaa yhteyden milloin tahansa alla olevasta linkistä. Olet nyt valmis kutsumaan hakijoita tapaamisiin.`,
        revokeAuthorization: 'Poista yhteys kalenteriin',
      },
      personalInterview: {
        title: 'Sovi tapaaminen',
        description: ' Tapaamisen sopimiseksi voit antaa hakijalle mahdollisuuden tehdä varauksen itse kalenterinäkymässä vapaana olevista ajoista. Aluksi valitse tapaamiseen osallistujat. Seuraavaksi määrittele tapaamiselle sopivat päivämäärät, kellonajat sekä tapaamisen kesto. Halutessasi voit muokata myös kutsuviestiä. Hakija saa sähköpostin, joka ohjaa tapaamisen varaamiseen. Hakijan varattua tapaamisen, haastattelijat saavat vahvistussähköpostin. Sähköposti sisältää sekä tapaamisen että hakijan tiedot. Tapaaminen päivittyy osallistujien kalentereihin.',
        interviewersHeader: 'Valitse haastattelijat',
        noInterviewersSelectedRegular: 'Valitse vähintään yksi haastattelija.',
        noInterviewersSelected: 'Valitse vähintään yksi haastattelija, jonka kalenteri on yhdistetty Recrightiin.',
        otherInterviewersHeader: 'Muut haastattelijat',
        removeOtherInterviewers: 'Poista',
        deselectAll: 'Tyhjennä valinnat',
        selectAll: 'Valitse kaikki',
        interviewerCalendarNotConnected:
          'Haastattelijan kalenteria ei ole yhdistetty Recrightiin, joten hänen vapaat aikansa eivät ole saatavilla.',
        interviewerCalendarNotConnected2:
          'Haastattelijalle lähetetään kuitenkin automaattisesti sähköposti kalenterin yhdistämisestä ja sovitusta tapaamisesta.',
        singleInterviewer: 'Haastattelija',
        allInterviewersCalendarNotConnected: 'Yhdenkään haastattelijan kalenteri ei ole yhdistetty Recrightiin.',
        addMoreInterviewersToTeam: 'Klikkaa tästä lisätäksesi lisää haastattelijoita tiimiin.',
        userCalendarNotConnected: 'Kalenteriasi ei ole yhdistetty Recrightiin',
        userConnectCalendar: 'Yhdistä kalenterisi täältä',
        addNewInterviewer: 'Lisää uusien haastattelijoiden sähköpostit',
        timeSlot: {
          description: 'Määritä aikaväli, jolloin haluat haastattelun pidettävän, vapaat kellonajat, ja ajan pituus. Kun olet valinnut haastattelijat ja määrittänyt aikarajan, näet kalenterista vapaat ajat.',
          startDate: 'Aikavälin aloituspäivämäärä',
          endDate: 'Aikavälin päättymispäivämäärä',
          endDatePlaceholder: 'Päättymispäivä',
          startDatePlaceholder: 'Alkamispäivä',
          endDateWarning: 'Valitse päättymispäivämäärä',
          startTime: 'Alkamiskellonaika',
          endTime: 'Päättymiskellonaika',
          timezone: 'Aikavyöhyke',
          timezoneHelp: 'Huomioithan, että aikavyöhykkeen vaihtaminen vaihtaa myös valittuja kellonaikoja.',
        },
        recipients: count => `Kutsu lähetetään ${count} hakijalle`,
        confirmRescheduleMessage: 'Sovi tapaaminen uudelleen',
        confirmRescheduleContent: 'Osa valituista hakijoista on jo kutsuttu tapaamiseen. Haluatko lähettää heille uuden kutsun? Tämä kutsu korvaa heidän kanssaan aikaisemmin sovitun tapaamisen.',
        useAllTimeSlots: 'Hakija voi vapaasti valita minkä tahansa vapaista ajoista aikarajan sisältä. Poistamalla valinnan tästä valintaruudusta voit valita yksittäisiä aikoja kalenterista. Hakija voi silloin valita tapaamisajan vain näistä yksittäisistä ajoista.',
        noTimeSlotsSelected: 'Valitse vähintään yksi ajankohta alapuolella olevasta kalenterista tai anna hakijan valita mikä tahansa vapaa aika aikaväliltä klikkaamalla valintaruutua yläpuolella.',
        slotPickerDescription: 'Näytä vapaat tapaamisajankohdat. Kalentereihin tehdyt muutokset päivittyvät automaattisesti Recrightiin.',
        showAvailability: 'Näytä vapaat ajat',
        refreshAvailability: 'Päivitä näkymä',
        slotLength: 'Tapaamisen pituus',
        availabilityError: 'Vapaita aikoja ei voida näyttää. Yritä myöhemmin uudelleen. Jos ongelma ei katoa, olethan yhteydessä tukeemme.',
      },
      personalInterviewMessage: {
        title: 'Kirjoita kutsuviesti',
        successTitle: 'Great',
        successDescription: candidateLength => `Kutsuit ${candidateLength} hakijaa sovittuun tapaamiseen. Heidät on nyt sirretty vaiheseen 'Sovittu tapaaminen'`,
        message: {
          emailMessage: 'Viesti',
          title: title => `Kutsu tapaamiseen: ${title}`,
          content: title => `Hei, Hakemuksesi työpaikkaan: ${title} oli vaikuttava ja haluaisimme kutsua sinut henkilökohtaiseen haastatteluun.\n\nValitse sinulle sopivin ajankohta tapaamiselle klikkaamalla linkkiä.\n\nNähdään pian!`,
          event: {
            header: 'Tapaamispaikka',
            description: 'Kalenterimerkinnän tiedot:',
            titlePlaceholder: 'Tapaamisen otsikko',
            locationPlaceholder: 'Lisää tapaamispaikka',
          },
        },
        close: 'Sulje',
        saveDefaultLocation: 'Tallenna tapaamispaikka oletukseksi',
        savedDefaultLocation: 'Tallennettu ensisijaiseksi tapaamispaikaksi',
        invitationError: 'Emme valitettavasti pystyneet lähettämään kalenterikutsuja. Yritä myöhemmin uudelleen. Jos ongelma ei katoa, olethan yhteydessä tukeemme.',
      },
    },

    modalVideoEdit: {
      title: 'Muokkaa videota',
      cancel: 'Peruuta',
      save: 'Tallenna',
      addToCollection: 'Lisää kokoelmaan',
      success: 'Videoon tehdyt muutokset tallennettu onnistuneesti!',
      error:
        'Emme valitettavasti pystyneet tallentamaan muutoksia. Yritä myöhemmin uudelleen. Jos ongelma ei katoa, olethan yhteydessä tukeemme.',
    },

    noResults: {
      description: 'Ei tuloksia. Yritä uudelleen vähentämällä rajauksia.',
    },

    notifications: {
      notifications: 'Ilmoitukset',
    },

    notificationsSubscribeButton: {
      subscribe: 'Tilaa ilmoitukset',
      subscribed: 'Ilmoitukset Tilattu',
      unsubscribe: 'Peruuta ilmoitukset',
    },

    onboardTutorial: {
      ui: {
        back: 'Takaisin',
        close: 'Sulje',
        last: 'Ok!',
        next: 'Seuraava',
        skip: 'Lopeta',
      },
      dashboard: [
        {
          title: 'Tervetuloa Recrightiin',
          text: 'Aloitetaan yhdistämällä kalenterisi Recrightiin voidaksesi sopia tapaamisia helposti hakijoiden kanssa. <a href="/admin/account">Yhdistä kalenterisi täältä!</a>',
          selector: '.joyride--welcome-calendar',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: 'Tervetuloa Recrightiin',
          text: 'Opastamme sinua ohjelman käytössä interaktiivisilla opasteilla. Klikkaamalla pulssia näet kyseisen toiminnon ohjeistuksen. Voit kytkeä opastuksen milloin vain takaisin päälle klikkaamalla nimeäsi ja “Näytä opastus”.',
          selector: '.joyride--welcome',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: 'Luo uusi työpaikka',
          text: 'Luo ja julkaise työpaikkailmoitus täältä.',
          selector: '.joyride--add-job-ad',
          position: 'bottom',
        },
        {
          title: 'Luo uusi videohaastattelu',
          text: 'Luo videohaastattelu ja kutsu siihen hakijoita täältä.',
          selector: '.joyride--add-videointerview',
          position: 'bottom',
        },
        {
          title: 'Asetusvalikko',
          text: 'Muuta täällä tilisi asetuksia, määrittele urasivuston ulkoasu ja osoite, hallinnoi videokirjastoasi sekä vaihda käyttöliittymän kieltä. Täältä voit myös kytkeä opastuksen takaisin päälle.',
          selector: '.joyride--profile-settings',
          position: 'bottom-left',
        },
      ],
      accountDetails: [
        {
          title: 'Yhdistä kalenterisi täältä!',
          text: ' Yhdistettyäsi kalenterin Recrightiin, voit kutsua hakijoita tapaamisiin. Tapaamiset päivittyvät kalenteriisi automaattisesti.',
          selector: '.joyride--connect-calendar',
          position: 'top',
        },
      ],
      jobAdEdit: [
        {
          title: 'Lisää taustakuva ja logo',
          text: 'Lisää taustakuva sekä logo ilmoituksen yhteyteen. Taustakuvan optimaalinen koko on 1440 x 320 pikseliä ja se näkyy hakijalle työpaikan yläosassa.',
          selector: '.joyride--job-ad-images',
          position: 'top',
        },
        {
          title: 'Otsikko, sijainti, julkaisupäivä, voimassa',
          text: 'Kirjoita tehtävänimike, sijainti, työpaikan julkaisupäivä sekä viimeinen hakuajankohta. Jos jätät viimeisen hakuajankohdan tyhjäksi, niin työpaikka on avoinna toistaiseksi.',
          selector: '.joyride--job-ad-title',
          position: 'top',
        },
        {
          title: 'Työn kuvaus',
          text: 'Kirjoita työpaikan kuvaus tähän. Kerro mitä haetaan, mitkä ovat vaatimukset sekä mitä tarjoat.',
          selector: '.joyride--job-ad-description',
          position: 'top',
        },
        {
          title: 'Työnantajavideo',
          text: 'Tuo esille yrityksesi kulttuuria ja paranna työnantajamielikuvaa lisäämällä ilmoitustekstin yhteyteen työnantajavideo.',
          selector: '.joyride--job-ad-employer-video',
          position: 'top',
        },
        {
          title: 'Hakemuslomakkeella pyydettävät tiedot',
          text: 'Valitse mitä tietoja haluat tietää hakijoista. Tiedot voivat olla vapaaehtoisia tai pakollisia.',
          selector: '.joyride--job-ad-application-setup',
          position: 'top',
        },
        {
          title: 'Haastattelukysymys',
          text: 'Esitä videokysymys jo hakemusvaiheessa nähdäksessi persoona hakemuksen takana. Tämä on myös loistava mahdollisuus tervehtiä hakijoita.',
          selector: '.joyride--job-ad-video-questions',
          position: 'right',
        },
      ],
      interviewEdit: [
        {
          title: 'Lisää taustakuva ja logo',
          text: 'Lisää taustakuva sekä logo haastattelun yhteyteen. Taustakuvan optimaalinen koko on 1440 x 320 pikseliä ja se näkyy hakijalle haastattelun yläosassa.',
          selector: '.joyride--interview-images',
          position: 'top',
        },
        {
          title: 'Otsikko, voimassa',
          text: 'Nimeä videohaastattelu ja aseta sille viimeinen vastaamispäivämäärä. Mikäli haluat haastattelun olevan avoinna toistaiseksi, jätä “Voimassa” täyttämättä.',
          selector: '.joyride--interview-title',
          position: 'top',
        },
        {
          title: 'Haastattelulomakkeella pyydettävät tiedot',
          text: 'Valitse mitä tietoja haluat tietää hakijoista. Tiedot voivat olla vapaaehtoisia tai pakollisia.',
          selector: '.joyride--interview-form-setup',
          position: 'top',
        },
        {
          title: 'Haastattelukysymykset',
          text: 'Nauhoita, lataa tai valitse kirjastosta haastattelukysymykset. Voit luoda myös tekstikysymyksiä jos sinulla ei ole mahdollisuutta käyttää videota, hakija vastaa kuitenkin aina videolla.',
          selector: '.joyride--interview-video-questions',
          position: 'top',
        },
      ],
      createdJobAd: [
        {
          title: 'Työpaikan toiminnot',
          text: 'Täältä voit palata muokkaamaan ilmoitusta, muuttaa sen statusta sekä kutsua kollegasi arvioimaan hakemuksia.',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: 'Työpaikan julkaisu',
          text: 'Jaa työpaikkailmoitusta sosiaalissa kanavissa, saadaksesi sille mahdollisimman suuren näkyvyyden.',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      createdInterview: [
        {
          title: 'Videohaastattelun toiminnot',
          text: 'Täältä voit palata muokkaamaan haastattelua, muuttaa sen statusta sekä kutsua kollegasi arvioimaan hakijoita.',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: 'Videohaastattelun julkaisu',
          text: 'Kutsu hakijat haastatteluun tai tee haastattelusta julkinen, ja jaa sitä sosiaalissa kanavissa.',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      ApplicationView: [
        {
          title: 'Kommentit ja luokittelut',
          text: 'Voit kommentoida, lisätä luokitteluja sekä antaa hakijoille tähtiä. Muista merkitä hakijalle status, kun olet tehnyt päätöksen hakijan suhteen. Hakija ei näe näitä tietoja. Muistathan ilmoittaa hakijalle kun olet tehnyt päätöksesi.',
          selector: '.joyride--comments',
          position: 'top',
        },
      ],
    },

    organisationSubMenu: {
      index: 'Organisaation profiili',
      branding: 'Brändäys',
      stages: 'Rekrytointivaiheet',
      emailTemplates: 'Sähköpostipohjat', // TODO: something else?
      evaluationScales: 'Arviointiasteikot',
      competencies: 'Oletuskompetenssit',
    },

    statisticsSubMenu: {
      linkToDetailed: 'Tarkemmat tiedot',
      linkToSummary: 'Yhteenveto',
    },

    passcode: {
      passcode: 'Pääsykoodi',
      showPasscode: 'Näytä pääsykoodi',
      hidePasscode: 'Piilota pääsykoodi',
    },

    passwordIndicator: {
      errors: [
        'Salasanassa tulee olla vähintään 12 merkkiä.',
        'Salasanassa tulee olla alle 128 merkkiä.',
        'Salasanassa ei saa olla yli kahta samanlaista peräkkäistä merkkiä.',
        'Salasanassa tulisi olla vähintään yksi pieni kirjain: a-z',
        'Salasanassa tulisi olla vähintään yksi iso kirjain: A-Z',
        'Salasanassa tulisi olla vähintään yksi numero: 0-9',
        'Salasanassa tulisi olla vähintään yksi erikoismerkki: (esim. !, #, &)',
      ],
      strengthLabel: 'Salasanan vahvuus: ',
      strengthValue: {
        insufficient: 'Riittämätön',
        weak: 'Heikko',
        medium: 'Kohtalainen',
        strong: 'Vahva',
      },
      learnMore: 'Opettele luomaan vahva salasana',
    },

    personDetails: {
      namePlaceholder: 'Hakija',
      links: 'Linkit',
      attachments: 'Liitteet',
      coverLetter: 'Kuvaus',
      referrer: 'Viitesivu',
      referrerInfo: 'Sivusto, jolta hakija saapui palveluun.',
      lastSeen: time => `Viimeksi nähty ${time}.`,
      headerAdditionalInformation: 'Lisätietoja',
      state: {
        invited: 'Kutsuttu',
        visited: 'Vieraillut',
        incomplete: 'Kesken',
        completed: 'Valmis',
      },
      liveCandidateState: {
        scheduling: 'Haastatteluajan valinta',
        notInvited: 'Kutsua ei lähetetty',
        invited: 'Kutsuttu',
        interviewed: 'Haastateltu',
        evaluated: 'Arvioitu',
      },
      notVisited: 'Ei ole vielä käynyt haastattelussa.',
      otherPersons: count => `Hakija löytyy myös ${count} muusta positiosta`,
      name: 'Nimi',
      email: 'Sähköposti',
      phone: 'Puhelinnumero',
      city: 'Kaupunki',
      deadline: date => `Määräaika: ${date}`,
      deadlineExpired: 'Määräaika umpeutunut',
    },

    personEdit: {
      header: 'Muokkaa hakijan tietoja',
      description: context => `Voit muokata kaikkia perustietoja, jotka näkyvät hakijoille ${context === 'application' ? 'hakemuslomakkeella' : 'haastattelulomakkeella'}.`,
      name: 'Hakijan nimi',
      email: 'Hakijan sähköposti',
      phone: 'Hakijan puhelinnumero',
      city: 'Hakijan nykyinen kotikaupunki',
      link: 'Lisää linkki, esim. hakijan LinkedIn -profiili',
      links: 'Lisää linkkejä, esim. hakijan LinkedIn -profiili',
      coverLetter: 'Saatekirje',
      attachments: 'Liitteet',
      save: 'Tallenna',
      cancel: 'Peruuta',
      editDetails: 'Muokkaa tietoja',
      editSuccess: 'Hakijan tiedot tallennettu!',
    },

    personRow: {
      email: 'Sähköposti',
      noStage: 'Ei vielä siirretty vaiheeseen',
      lastSeen: time => `Viimeksi nähty ${time}.`,
      notVisited: 'Ei ole vielä käynyt haastattelussa.',
      createdAt: 'Luontiaika',
      lastAction: 'Viimeinen tapahtuma',
      selectPerson: 'Valitse',
      deselectPerson: 'Poista valinta',
      openPersonPage: 'Avaa',
      interviewStartTime: 'Haastattelun aloitusaika',
      noStartTimeSelected: 'Aikaa ei ole valittu',
      icons: {
        messages: messagesSent => `${messagesSent} viestiä lähetetty`,
        message: messagesSent => `${messagesSent} viesti lähetetty`,
        noMessages: 'Ei lähetettyjä viestejä',
        introduction: introductions => `${introductions} esittely`,
        introductions: introductions => `${introductions} esittelyä`,
        noIntroductions: 'Ei esittelyjä',
        comment: comments => `${comments} kommentti`,
        comments: comments => `${comments} kommenttia`,
        noComments: 'Ei kommentteja',
        appliedWithLinkedIn: 'Hakemus täytetty LinkedIn-profiililla',
      },
      state: {
        invited: 'Kutsuttu',
        visited: 'Vieraillut',
        incomplete: 'Kesken',
        completed: 'Valmis',
        scheduling: 'Haastatteluajan valinta',
        notInvited: 'Kutsua ei lähetetty',
        interviewed: 'Haastateltu',
        evaluated: 'Arvioitu',
      },
      deadline: date => `Määräaika: ${date}`,
      deadlineExpired: 'Määräaika umpeutunut',
    },

    pipeline: {
      editInterview: 'Muokkaa haastattelua',
      titleLabel: 'Nimi',
      endTimeLabel: 'Voimassa',
      statusLabel: 'Status',
      locationLabel: 'Sijainti',
      editStages: 'Muokkaa vaiheita',
      interviewSchedulingDescription: 'This stage contains candidates that have peen invited to a personal meeting.',
      pipelineTooltip: 'Hallinnoi hakijoita vaiheiden avulla. Siirrä hakijoita vaiheesta toiseen rekrytoinnin edetessä. Voit myös suodattaa hakijoita vaiheiden ja muiden suodattimien mukaan.',
    },

    positionListing: {
      type: 'Position tyyppi',
      title: 'Position nimi',
      owner: 'Omistaja',
      created: 'Luontipäivä (GMT)',
      start: 'Julkaisupäivä (GMT)',
      end: 'Sulkeutumispäivä (GMT)',
      count: 'Lukumäärä',
      invited: 'Kutsuttu',
      visited: 'Käynyt',
      answered: 'Vastannut',
      hired: 'Palkattu',
      leadTime: 'Läpimenoaika',
      leadTimeValue: v => `${v} päivää`,
      jobAdLabel: 'Työpaikkailmoitus',
      interviewLabel: 'Videohaastattelu',
      timedLabel: 'Aikarajattu haastattelu',
      embedLabel: 'Upotettu haastattelu',
      publicLabel: 'Julkinen haastattelu',
      timezone: 'Aikavyöhyke',
      feedback: 'Hakijoiden palaute',
    },

    qrCodeDownload: {
      download: 'Lataa QR-koodi',
    },

    recentPositionsContainer: {
      createNew: 'Luo uusi',
      showAll: 'Näytä kaikki',
    },

    recentJobAds: {
      openJobPositions: 'Työpaikat',
      showAllJobPositions: 'Näytä kaikki työpaikat',
      createNewJobPosition: 'Luo uusi työpaikka',
      subscriptionNeeded: 'Tarvitset voimassa olevan tilauksen julkaistaksesi työpaikkailmoituksen.',
      confirmSingleHire: 'Ostamasi yksittäinen rekrytointi käytetään tähän työpaikkailmoitukseen.',
      newApplications: 'Näkemättömät',
      responses: 'Hakemuksia',
    },

    recentInterviews: {
      openVideoInterviews: 'Videohaastattelut',
      showAllVideoInterviews: 'Näytä kaikki videohaastattelut',
      createNewVideoInterview: 'Luo uusi videohaastattelu',
      invites: 'Kutsuja',
      responses: 'Vastauksia',
      timedTitle: 'Aikarajattu haastattelu',
    },

    registrationForm: {
      email: 'Sähköpostiosoite',
      submit: 'Kirjaudu palveluun',
      password: 'Salasana',
      confirmPassword: 'Salasana uudelleen',
      name: 'Nimi',
      namePlaceholder: 'Etunimi Sukunimi',
      agreeTos: 'Olen lukenut ja hyväksyn ',
      agreeTosLinkText: 'Recrightin käyttöehdot.',
      privacyPolicy: 'Olen tutustunut ',
      privacyPolicyLinkText: 'Tietosuojaselosteeseen.',
      licenseAgreement: 'Hyväksyn edustamani yrityksen puolesta ',
      licenseAgreementLinkText: 'Recrightin käyttöoikeussopimuksen.',
      newsletter: 'Tilaan kuukausittaisen uutiskirjeen.',
      organization: 'Yritys',
      companyDomain: domain => `Liitä jatkossa ${domain} -sähköpostipäätteellä rekisteröityvät käyttäjät tähän yritykseen`,
      error: {
        password: {
          isRequired: 'Salasana on pakollinen. ',
          isValidPassword: 'Salasanan pitää olla vähintään 12 merkkiä pitkä, ja siinä pitää olla ainakin yksi iso kirjain, yksi pieni kirjain ja yksi numero.',
          passwordsMatch: 'Salasanat eivät täsmää. ',
        },
      },
    },

    subscriptionNeededAlert: {
      contactPersonWithBillingPermission: 'Ole yhteydessä organisaatiosi tilauksesta vastuussa olevaan henkilöön.',
    },

    search: {
      placeholder: 'Etsi',
    },

    searchFilter: {
      filter: 'Rajaa hakua',
      headings: {
        location: 'Sijainti',
        state: 'Hakijan tila',
        status: 'Status',
        tags: 'Tagit',
        rating: 'Arvosana',
        stage: 'Vaihe',
      },
      state: {
        invited: 'Kutsuttu',
        visited: 'Vieraillut',
        incomplete: 'Kesken',
        completed: 'Valmis',
        scheduling: 'Haastatteluajan valinta',
        notInvited: 'Kutsua ei lähetetty',
        interviewed: 'Interviewed',
        evaluated: 'Evaluated',
      },
      status: {
        open: 'Avoin',
        filled: 'Täytetty',
        cancelled: 'Peruttu',
        closed: 'Suljettu',
        draft: 'Luonnos',
        hidden: 'Piilotettu',
        unpublished: 'Luonnos',
        hired: 'Palkattu',
        proceed: 'Käsittelyssä',
        new: 'Uusi',
        all: 'Kaikki',
        videointerviewed: 'Videohaastattelu',
        personalinterview: 'Henkilökohtainen haastattelu',
        withdrawn: 'Vetäytynyt prosessista',
        scheduledinterview: 'Sovittu tapaaminen',
        rejected: 'Hylätty',
        finished: 'Päättynyt',
        coming: 'Tulossa',
        active: 'Käynnissä',
      },
    },

    selectListings: {
      title: 'Julkaisusivut',
      description: 'Valitse missä työpaikkailmoitus julkaistaan.',
    },

    session: {
      account: 'Tiliasetukset',
      language: 'Kieli',
      logout: 'Kirjaudu ulos',
      whatsNew: 'Uutta Recrightissa',
      trainingMaterial: 'Recright-koulutukset',
      expired: 'Ole hyvä ja kirjaudu sisään uudelleen.',
      showTutorial: 'Näytä opastus',
      helpCenter: 'Recright-tukisivusto',
      organization: 'Yritys',
    },

    showFeedbackPulse: {
      showPulse: 'Näytä palaute',
      positive: avg => `${avg}% Positiivista`,
      feedbackStatistics: 'Yhteenveto',
      noFeedback: 'Ei vielä palautteita',
      responses: responses => `${responses} Vastausta`,
    },

    singleHireUseNotification: {
      notificationHeader: count => `Sinulla on ${count} yksittäistä rekrytointia käytettävissä tililläsi.`,
      notificationBody: 'Kutsumalla hakijoita tai julkaisemalla ilmoituksen, yksi lisenssi käytetään automaattisesti.',
    },

    singleHires: {
      currentCount: count => `${count} yksittäistä rekrytointia käytettävissäsi.`,
      purchase: 'Osta yksittäinen rekrytointi',
      label: 'Yksittäinen rekrytointi',
      confirmMessage: amount => `Vahvista yksittäisen lisenssin osto yhtä rekrytointia varten. ${amount} EUR veloitetaan tililtäsi.`,
    },

    smartrecruitersPublish: {
      title: 'Smartrecruiters-Integraatio',
      description: 'Voit lisätä ja poistaa yksittäisiä videohaastatteluita Smartrecruiters listalta.',
      notification: 'Huomioithan, että videohaastattelun näkymiseen Smartrecruiters listalla voi kulua 24 tuntia.',
      addButton: 'Lisää Smartrecruiters -listalle',
      removeButton: 'Poista Smartrecruiters -listalta',
      confirmRemove: 'Oletko varma, että haluat poistaa videohaastattelun Smartrecruiters listalta?',
      addConflict: 'Haastattelu  on jo lisätty integraation videohaastattelulistalle',
      removeConflict: 'Haastattelu  on jo poistettu integraation videohaastattelulistalta',
    },

    subscriptionExpired: {
      message: 'Tilauksesi on päättynyt.',
    },

    stars: {
      yourRating: rating => `Oma arvio: ${rating}`,
      totalVotes: count => `Yhteensä ${count} arviota`,
      yourRatingReset: 'Poista arviosi',
    },

    statisticsFilters: {
      timeframe: 'Näytettävä aikaväli:',
      owner: 'Omistaja (Valinnainen)',
    },

    csStatisticsFilters: {
      timeframe: 'Näytettävä aikaväli:',
      autoSuggestCompany: 'Yrityksen nimi',
      companyId: 'Yrityksen ID',
      companyDomain: 'Yrityksen sähköpostipääte',
      note: 'Huomio: ',
      noteText:
        'Yrityksen nimi on merkkikokoriippuvainen. Yrityksen nimi ehdotukset näytetään vain yrityksille joilla on > 1 ilmoitusta tai paikkaa.',
    },

    statisticsSummary: {
      jobCountLabel: 'Avoimet työpaikkailmoitukset',
      interviewsLabel: 'Videohaastattelut',
      applicationsLabel: 'Työhakemukset',
      answersLabel: 'Videohaastatteluvastaukset',
      activeUsersLabel: 'Aktiiviset käyttäjät',
      avgLeadTimeLabel: 'Keskimääräinen läpimenoaika',
      avgLeadTimeValue: value => `${value} päivää`,
    },

    status: {
      opening: {
        open: 'Avoin',
        filled: 'Täytetty',
        cancelled: 'Peruttu',
        closed: 'Suljettu',
        draft: 'Luonnos',
        hidden: 'Piilotettu',
        unpublished: 'Luonnos',
      },
      person: {
        hired: 'Palkattu',
        proceed: 'Käsittelyssä',
        new: 'Uusi',
        videointerviewed: 'Videohaastattelu',
        personalinterview: 'Henkilökohtainen haastattelu',
        withdrawn: 'Vetäytynyt prosessista',
        scheduledinterview: 'Sovittu tapaaminen',
        rejected: 'Hylätty',
      },
    },

    trialBanner: {
      notification: days => `Kokeilujaksoasi on jäljellä ${days} päivää. Jos haluat jatkaa käyttöä kokeilujakson päätyttyä, sinun on ostettava lisenssi tai yksittäinen rekrytointi.`,
      trialEnded: 'Kokeilujaksosi on nyt päättynyt. Jos haluat jatkaa palvelun käyttöä, sinun on ostettava lisenssi tai yksittäinen rekrytointi.',
      orderHere: 'Tilaa tästä!',
    },

    favorite: {
      popupHeader: 'Valitse videokirjasto',
      yourVideos: 'Omat videosi',
      companyVideos: 'Organisaation videot',
    },

    FavoritesInfo: {
      Favorites: videoLibrary => `Lisää video suosikkeihisi klikkaamalla videon päällä olevaa sydäntä. Voit poistaa videon suosikeistasi <a href="${videoLibrary}">Videokirjastosta</a>.`,
    },

    brandingPreview: {
      preview: 'Esikatselu',
      header: 'Esimerkkiotsikko',
      body: lorem => `Tämä on esimerkkileipätekstin fontti. ${lorem}`,
      linkText: 'Tämä on esimerkkilinkki',
      primaryButtonText: 'Ensisijainen painike',
      secondaryButtonText: 'Toissijainen painike',
      backButtonText: 'Takaisin-painike',
      buttonText: 'Esimerkkipainike',
    },

    usersList: {
      generalInformation: 'Perustiedot',
      latestVisit: date => `Viimeksi aktiivisena ${date}`,
      neverLogger: 'Ei vielä kirjautunut',
      externalUser: 'Ulkoinen käyttäjä',
      inviteExpired: 'Kutsu vanhentunut',
      permissions: {
        permissions: 'Pääsyoikeudet',
        seeAllPositions: 'Näe kaikki positiot',
        createJobPositions: 'Työpaikkojen luonti',
        createInterviews: 'Haastatteluiden luonti',
        account: 'Yritysprofiilin muokkaus',
        billing: 'Laskutus',
        reporting: 'Raportointi',
        editUsers: 'Käyttäjähallinta',
        default: 'Oletusoikeudet',
      },
      actions: {
        actions: 'Toiminnot',
        activate: 'Aktivoi tunnus',
        deactivate: 'Sulje tunnus',
        removeFromOrganisation: 'Poista organisaatiosta',
        hiddenPositions: 'Piilotetut positiot',
      },
      noUsers: 'Ei tuloksia. Yritä uudelleen vähentämällä rajauksia.',
    },

    usersListFilters: {
      sort: {
        name: 'Nimi',
        email: 'Sähköposti',
        lastAdminAccess: 'Viimeksi aktiivisena',
      },
      find: 'Etsi',
      clearSelections: 'Tyhjennä valinnat',
      usersCount: count => `Yhteensä ${count} käyttäjää`,
    },

    usersListActions: {
      editMultipleUsersPermissions: 'Muokkaa usean käyttäjän oikeuksia',
      deactivateSelectedUsers: 'Sulje valitut käyttäjät',
      activateSelectedUsers: 'Aktivoi valitut käyttäjät',
      addNewUsers: 'Kutsu käyttäjiä',
      save: 'Tallenna',
      cancel: 'Peruuta',
      editUsersPermissions: 'Muokkaa käyttäjien oikeuksia',
    },

    linkedInInformation: {
      title: 'LinkedIn-profiili:',
      since: 'Aloituspäivä',
      summary: 'Kuvaus:',
      fullLinkedInProfile: 'Näytä koko LinkedIn-profiili',
    },

    colorPicker: {
      reset: 'Reset',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Vastaanotimme automaattisen vastausviestin. Varmista, että vastaanottaja sai viestin.',
      },
      Permanent: {
        General: 'Viestin lähetys epäonnistui. Vastaanottajan sähköpostipalveluntarjoaja hylkäsi viestin.',
        NoEmail: 'Sähköpostiosoitetta ei ole olemassa.',
        Suppressed: 'Sähköpostia ei toimitettu useiden epäonnistuneiden lähetysyritysten takia.',
      },
      Transient: {
        General: 'Vastaanotimme automaattisen vastausviestin. Varmista, että vastaanottaja sai viestin.',
        MailboxFull: 'Vastaanottajan sähköpostilaatikko on täynnä.',
        MessageTooLarge: 'Viestin sisältö on liian iso.',
        ContentRejected: 'Vastaanottajan sähköpostipalvelu ei hyväksynyt viestin sisältöä.',
        AttachmentRejected: 'Vastaanottajan sähköpostipalvelu ei hyväksynyt viestin liitteitä.',
      },
    },

    videoBackgroundUpload: {
      header: 'Organisaation taustakuva videoille',
      description:
        'Organisaation käyttäjät voivat käyttää tätä taustakuvaa nauhoittaessaan videoita.',
      add: 'Lisää videon taustakuva',
      info: 'Suositeltu kuvan koko on 720x480 pikseliä.',
    },
  },

  page: {
    account: {
      title: 'Tiliasetukset',
      details: 'Tilin tiedot',
      name: 'Tilin nimi',
      save: 'Tallenna',
      saved: 'Käyttäjätilin tiedot tallennettu.',
      signature: 'Allekirjoitus',
      permissions: 'Pääsyoikeudet',
      calendar: {
        label: 'Kalenteri',
        notAuthorized: 'Yhdistä kalenterisi täältä',
        authorized: 'Hallinnoi kalenteriyhteyttä',
        revokeError: 'Emme pystyneet valitettavasti poistamaan yhteyttä kalenteriisi. Yritä myöhemmin uudelleen. Jos ongelma ei katoa, olethan yhteydessä tukeemme.',
        revokeSuccess: 'Yhteys kalenteriin poistettu',
      },
      password: 'Salasana',
      statistics: 'Tilastot',
      organization: 'Yritys',
    },

    actionBar: {
      selection: 'valittu',
    },

    organisationProfile: {
      title: 'Organisaation profiili',
      details: 'Organisaation profiiliasetukset',
      brandingHeader: 'Organisaation brändäysasetukset',
      name: 'Organisaation nimi',
      owner: 'Tilin omistaja',
      customReplyToSubtitle:
        'Kutsuviestin lähettäjän nimi ja vastausosoite. Jos jätät kentät tyhjiksi, käytetään kutsujen lähettävän käyttäjän nimeä ja sähköpostia.',
      customReplyToEmail: 'Vastaussähköposti kutsuviesteille',
      customReplyToName: 'Lähettäjän nimi kutsuviestissä',
      senderInfoDisabled:
        'Haastattelun kutsuviestin lähettäjän nimeä tai vastausosoitetta ei voi muokata, koska videohaastattelut eivät ole käytössä.',
      slug: 'Urasivuston URL',
      slugUnavailable: 'Tämä osoite on jo varattu.',
      slogan: 'Urasivuston slogan',
      language: 'Urasivuston kieli',
      languagePlaceholder: 'Valitse',
      rss: 'Urasivuston RSS-syöte',
      type: 'Tilin tyyppi',
      types: {
        free: {
          title: 'Ilmainen',
          description: 'Ilmaisen edut\n1 käyttäjä\n1 yksi avoin työpaikkailmoitus kerrallaan',
        },
        basic: {
          title: 'Perus',
          description: 'Ilmaisen edut\nRajoittamaton määrä avoimia työpaikkailmoituksia\nVideohaastattelut',
        },
        team: {
          title: 'Tiimi',
          description: 'Tiimin edut\nRajoittamaton määrä avoimia työpaikkailmoituksia\nVideohaastattelut\nKandidaattien esittelyt',
        },
      },
      save: 'Tallenna',
      reset: 'Palauta oletukset',
      companyAdminUsers: 'Company admin users',
      saved: 'Organisaation tiedot tallennettu.',
      cancel: 'Peruuta',
      confirmLeave: 'Muutoksia ei ole tallennettu. Haluatko varmasti poistua?',
      error: {
        required: '* Tähdellä merkityt kentät ovat pakollisia.',
      },
      emailBrandingHeader: 'Sähköpostien brändäysasetukset',
      emailBrandingDescription: 'Muokkaa hakijoille lähetettävien sähköpostiviestien värejä.',
    },

    organisationCompetencies: {
      title: 'Organisaation oletuskompetenssit',
      description: 'Voit muokata, lisätä ja poistaa organisaation oletuskompetensseja täältä. Nämä kompetenssit tulevat oletuksena uusiin tämän organisaation alle luotuihin positioihin ja ovat valmiina kaikilla näiden positioiden kandidaateilla "Osaaminen ja ominaisuudet" -osion alla.',
    },

    organisationStages: {
      title: 'Organisaation rekrytointivaiheet',
      description: 'Voit muokata, lisätä, järjestellä ja poistaa organisaation rekrytointivaiheita. Nämä rekrytointivaiheet tulevat oletuksena uusiin tämän organisaation alle luotuihin positioihin.',
    },

    organisationEvaluationScales: {
      language: 'Kieli',
      name: 'Nimi',
      description: 'Kuvaus',
      resetToDefaults: 'Palauta oletukset',
      confirmLanguageChange:
        'Oletko varma että haluat vaihtaa kieltä? Kaikki tekemäsi tallentamattomat muutokset katoavat.',
    },

    organisationEmailTemplates: {
      preview: 'Esikatsele sähköpostiviestiä (esikatselussa ei ole kaikkia lopullisen viestin muotoiluja)',
      preview2: 'Sähköpostiviestien värejä voi muokata organisaation brändäysasetuksissa.',
      timedInterviewPreviewInfo:
        'Aikarajatuista videohaastatteluista lähetetty viesti ei sisällä tekstiä, jossa puhutaan yhteyden ottamisesta asiakaspalveluun.',
      templateTypes: {
        interviewInvite: 'Videohaastattelukutsu',
        timedInterviewInvite: 'Kutsu aikarajattuun haastatteluun',
        interviewCompleted: 'Haastattelu lähetetty / kiitosviesti kandidaatille',
        applicationCompleted: 'Työpaikkahakemus lähetetty / kiitosviesti työnhakijalle',
      },
      subHeaders: {
        jobAdLabel: 'Työpaikkailmoitus',
        interviewLabel: 'Videohaastattelu',
      },
      deleteTemplate: 'Poista viestipohja',
      confirmation: templateName =>
        `Oletko varma että haluat poistaa viestipohjan "${templateName}" organisaatiosi viestipohjista?`,
      deleteSuccess: 'Viestipohja poistettiin organisaatiosi viestipohjista.',
      emailTemplateInfo:
        'Tämän ominaisuuden kehittäminen on vielä kesken. Tällä hetkellä voit tallentaa vain yhden viestipohjan.',
      templateError:
        'Saman niminen tai saman kielinen viestipohja on jo olemassa.',
    },

    application: {
      back: 'Takaisin hakemuslistaukseen',
      delete: 'Poista hakemus',
      deleted: 'Hakemus poistettu',
      interviewClosed: 'Haastattelu on suljettu.',
      resendInvitation: 'Lähetä kutsu uudelleen hakijalle',
      changeStage: 'Siirrä toiseen vaiheeseen',
      commentsAndClassifications: 'Kommentit ja luokittelut',
      openingTitle: title => `Videohaastattelu - ${title}`,
      yourRatingText: 'Oma arvio:',
      competencesAndCompatibility: 'Osaaminen ja ominaisuudet',
      duplicateCompetency: 'Ominaisuus on jo lisätty',
      competencyNotFound: 'Ominaisuutta ei löytynyt tai se on poistettu',
      confirmDelete: 'Haluatko varmasti poistaa tämän hakijan?',
      lastSeen: time => `Viimeksi nähty ${time}.`,
      stageChanged: 'Loistavaa!',
      stageChangedInfo: status => `Nyt kun olet siirtänyt hakijan vaiheeseen "${status}", ilmoita hänelle siitä! \n\n Lähetä sähköpostia tai videoviesti.`,
      close: 'Sulje',
      reopenProcessConfirm: 'Oletko varma, että haluat siirtää hakijan pois vaiheesta “Vetäytynyt prosessista” ja palauttaa hänet takaisin rekrytointiprosessiin? Tämän jälkeen hakija pääsee taas vastaamaan haastatteluun, jos se on hänellä kesken.',
      withdrawConfirm: 'Oletko varma, että haluat poistaa hakijan rekrytointiprosessista ja siirtää hänet vaiheeseen “Vetäytynyt prosessista”?  Tämän jälkeen hakija ei pääse enää vastamaan haastatteluun.',
      changestageTooltip: 'Tästä näet missä vaiheessa rekrytointiprosessia hakija on. Klikkaamalla voit siirtää hakijan haluttuun tilaa. Hakija ei näe näitä tietoja.',
      commentsTooltip: 'Voit lisätä kommentteja hakijasta. Hakija ei näe näitä tietoja.',
      competencesTooltip: 'Voit arvioida hakijan osaamista ja ominaisuuksia. Haastattelun jäsenet voivat lisätä, nähdä ja arvioida osaamisia ja ominaisuuksia. Hakija ei näe näitä tietoja.',
      actionlogTooltip: 'Kommentit, siirrot toiseen vaiheeseen, viestit ja muut tapahtumat näkyvät täällä. Hakija ei näe näitä tietoja.',
      stage: {
        new: 'Uusi',
        hired: 'Palkattu',
        proceed: 'Käsittelyssä',
        personalinterview: 'Henkilökohtainen haastattelu',
        withdrawn: 'Vetäytynyt prosessista',
        scheduledinterview: 'Sovittu tapaaminen',
        rejected: 'Hylätty',
        videointerviewed: 'Videohaastattelu',
      },
      state: {
        invited: 'Kutsuttu',
        visited: 'Käynyt',
        incomplete: 'Kesken',
        completed: 'Valmis',
      },
      notVisited: 'Ei ole vielä käynyt haastattelussa.',
      deadline: date => `Määräaika: ${date}`,
      deadlineExpired: 'Määräaika umpeutunut',
    },

    billing: {
      title: 'Laskutus',
      nextPayment: (nextBillingPeriodAmount, nextBillingDate) => `Seuraavan laskun summa ${nextBillingPeriodAmount} EUR veloitetaan ${nextBillingDate}`,
      status: 'Tila',
      singleHire: 'Yksittäinen rekrytointi',
      billingOverview: 'Laskutuksen yhteenveto',
      payment: 'Maksusuoritus',
      paymentHistory: 'Maksuhistoria',
      updateDetails: 'Muuta laskutustietoja',
      billingStatus: {
        pending: 'Odottaa käsittelyä',
        active: 'Aktiivinen',
        pastdue: 'Erääntynyt',
        expired: 'Vanhentunut',
        canceled: 'Peruttu',
      },
      noContractsFound: 'No contracts found. Please contact customer support.',
      monthlyPrice: 'Monthly Price:',
      productName: 'Product Name:',
      products: 'Products',
      nextInvoiceDate: 'Next Invoice Date:',
      monthlyValue: 'Monthly Value:',
      invoiceFrequency: 'Invoice Frequency:',
      months: '(months)',
      nextInvoiceSum: 'Next Invoice Sum:',
      contractStatus: 'Contract Status:',
      contractStartDate: 'Contract Start Date:',
      contractEndDate: 'Contract End Date:',
      termOfNotice: 'Term of Notice:',
      contract: 'Contract',
    },

    candidate: {
      actionLog: 'Tapahtumaloki',
      back: 'Takaisin hakijalistaukseen',
      delete: 'Poista hakija',
      deleted: 'Hakija poistettu',
      interviewClosed: 'Haastattelu on suljettu. Kutsuja ei lähetetty.',
      resendInvitation: 'Lähetä kutsu uudestaan hakijalle',
      changeStage: 'Siirrä toiseen vaiheeseen',
      introducedTo: 'Tehdyt esittelyt:',
      yourRatingText: 'Oma arvio:',
      competencesAndCompatibility: 'Osaaminen ja ominaisuudet',
      duplicateCompetency: 'Ominaisuus on jo lisätty',
      competencyNotFound: 'Ominaisuutta ei löytynyt tai se on poistettu',
      confirmDelete: 'Haluatko varmasti poistaa tämän hakijan?',
      stageChanged: 'Loistavaa!',
      stageChangedInfo: status => `Nyt kun olet siirtänyt hakijan vaiheeseen "${status}", ilmoita hänelle siitä! \n\n Lähetä sähköpostia tai videoviesti.`,
      close: 'Sulje',
      hideStages: 'Piilota vaiheet',
      showStages: 'Näytä vaiheet',
      resetQuestionResponseSuccess: 'Hakijan vastaus poistettiin',
      stage: {
        new: 'Uusi',
        hired: 'Palkattu',
        proceed: 'Käsittelyssä',
        personalinterview: 'Henkilökohtainen haastattelu',
        withdrawn: 'Vetäytynyt prosessista',
        scheduledinterview: 'Sovittu tapaaminen',
        rejected: 'Hylätty',
        videointerviewed: 'Videohaastattelu',
      },
      summaryOfAllAnswers: 'Yhteenveto kaikista vastauksista',
      summaryOfAllAnswersInsights: 'Yhteenveto kaikista havainnoista',
    },

    dashboard: {
      upcomingLiveInterviews: 'Live-haastattelut',
      showAllLiveInterviews: 'Näytä kaikki Live-haastattelut',
      createNewLiveInterview: 'Luo uusi Live-haastattelu',
      interviewRounds: 'Haastattelukierrokset',
      interviewGuides: 'Haastatteluopaspohjat',
      welcome: name => `Tervetuloa, ${name}!`,
      createNewGuide: 'Luo uusi haastatteluopaspohja',
      liveCard: {
        startTime: 'Ajankohta',
        interviewers: 'Haastattelijat',
        candidates: 'Hakijat',
      },
      interviewRoundCard: {
        interviews: 'Haastattelut',
        admins: 'Rekrytoijat',
        endTime: 'Voimassa',
      },
      oldLivesLinkText: 'Vanhat live-haastattelut',
    },

    interviewEdit: {
      title: 'Haastattelun otsikko',
      titleLabel: 'Haastattelun otsikko',
      location: 'Sijainti',
      publishTimePlaceholder: 'Julkaisupäivä',
      publishTimeTooltip: 'Lisää päivämäärä, jolloin haastattelu tulee julkiseksi. Voit vaihtaa päivämäärää milloin haluat.',
      endTime: 'Voimassa',
      endTimeTooltip: 'Lisää päivämäärä, jolloin vastausaika päättyy automaattisesti.',
      candidateAnswerTimeDays: 'Päiviä vastausten lähettämiseen',
      candidateAnswerTimeDaysTooltip: 'Aseta kuinka monta päivää hakijalla on aikaa vastata haastatteluun kutsun jälkeen. Jos julkaisupäivä on asetettu, määräaika lasketaan julkaisupäivästä. Jos haastattelun päättymisaika on ennen laskettua määräaikaa, päättymisaikaa käytetään sen sijaan.',
      candidateAnswerTimeDaysTooltipWithoutPublishTime: 'Aseta kuinka monta päivää hakijalla on aikaa vastata haastatteluun kutsun jälkeen. Jos haastattelun päättymisaika on ennen laskettua määräaikaa, päättymisaikaa käytetään sen sijaan.',
      candidateAnswerTimeDaysPlaceholder: 'Päiviä vastausten lähettämiseen ei ole asetettu',
      candidateAnswerTimeDaysInvalid: 'Arvon täytyy olla vähintään 1',
      unsetCandidateAnswerTimeDays: 'Poista',
      saveCandidateAnswerTimeDays: 'Tallenna',
      timezone: 'Aikavyöhyke',
      isNotPastDate: 'pvm on menneisyydessä.',
      interviewIsClosed: 'Haastattelu on suljettu. haluatko ',
      interviewIsClosedLink: 'avata sen',
      edit: {
        details: 'Muokkaa haastattelua',
        status: 'Vaihda haastattelun statusta',
        team: 'Muokkaa tiimiä',
      },
      descriptionText: 'Kuvaus',
      questions: 'Haastattelukysymykset',
      answerable: 'Kysymykseen voi vastata',
      required: 'Vastaus on pakollinen',
      questionsDescription: 'Nämä ovat kysymykset, joihin haastatteluun osallistujia pyydetään vastaamaan.',
      questionsNotEditable: 'Kysymykset eivät ole muokattavissa, kun kutsut on lähetetty.',
      saved: 'Haastattelu tallennettu',
      deleted: 'Haastattelu poistettu',
      delete: 'Poista haastattelu',
      cancel: 'Peruuta',
      save: 'Tallenna',
      language: 'Haastattelun kieli',
      languagePlaceholder: 'Valitse',
      languages: {
        en: 'English',
        fi: 'Suomi',
      },
      confirmLeave: 'Muutoksia ei ole tallennettu. Haluatko varmasti poistua?',
      OnboardingHeadImageSize: 'Suositeltu taustakuvan koko on 1440px*320px tai korkeampi.',
      answerTimeLabel: 'Vastausaika',
      preparationTimeLabel: 'Valmistautumisaika',
      takeLimitLabel: 'Ottojen määrä',
      confirmHeader: 'Oletko varma että haluat poistaa tämän haastattelun?',
      integratedConfirmContent: 'Tämä haastattelu on integroitu toiseen järjestelmään ja sen poistaminen saattaa aiheuttaa ongelmia integraatiossa.',
      evaluationCriteriaLabel: 'Arviointikriteerit',
    },

    interview: {
      endTime: date => (date ? `vastausaika päättyy ${date}` : ''),
      edit: 'Muokkaa haastattelua',
      copy: 'Kopioi haastattelu',
      editInvitation: 'Muokkaa kutsuviestiä',
      editTeam: 'Muokkaa tiimiä',
      editMenu: 'Muokkaa',
      questions: 'Haastattelukysymykset',
      changeStatus: 'Vaihda haastattelun statusta',
      publishSettings: 'Julkaisuasetukset',
      invite: 'Kutsu hakijoita',
      showCandidates: 'Näytä hakijat',
      oneError: 'Upotetussa haastattelussa voi olla vain yksi kysymys.',
      copySuccess: 'Haastattelu kopioitiin onnistuneesti',
      editIntroduceBatches: 'Muokkaa esittelyjä',
      editEmailSettings: 'Muokkaa sähköpostiasetuksia',
    },

    interviews: {
      allInterviews: 'Kaikki videohaastattelut',
      createNewVideoInterview: 'Luo uusi videohaastattelu',
      filter: 'Etsi haastattelu',
      invites: 'Kutsuja',
      responses: 'Vastauksia',
      sort: {
        title: 'Otsikko',
        endTime: 'Päättymisaika',
        publishTime: 'Julkaisupäivä',
        createdAt: 'Luontipäivämäärä',
        updatedAt: 'Viimeksi muokattu',
        answeredCount: 'Vastauksia',
      },
    },

    interviewCandidates: {
      preview: 'Esikatselu',
      endTime: date => (date ? `Vastausaika päättyy ${date}` : ''),
      publicTitle: 'Julkinen haastattelu',
      embedTitle: 'Upotettu haastattelu',
      placeholder: {
        first: 'Et ole vielä kutsunut ketään videohaastatteluun.',
        second: 'Voit myös julkaista videohaastattelusi avoimena.',
        third: 'Silloin kaikki tehtävästä kiinnostuneet voivat nähdä haastattelun ja hakea siihen.',
        fourth: 'Älä unohda, että kaikki nämä ovat yhden klikkauksen päässä otsikkopalkissa.',
      },
      title: 'Kaikki hakijat',
      sort: {
        default: 'Oletus',
        updatedAt: 'Viimeksi muokattu',
        name: 'Nimi',
        rating: 'Arvosana',
        createdAt: 'Luontipäivämäärä',
      },
      sendMessage: 'Lähetä viesti',
      changeStage: 'Siirrä toiseen vaiheeseen',
      introduce: 'Esittele',
      filter: 'Etsi hakijoita',
      hideFilters: 'Piilota suodattimet',
      showFilters: 'Näytä suodattimet',
      emailSent: 'Sähköposti lähetetty!',
      interviewClosedError: 'Et voi kutsua hakijaa uudestaan haastatteluun joka on suljettu',
      excel: 'Lataa hakijoiden tiedot exceliin',
      reInviteSent: candidates => `${candidates} uudelleenkutsua lähetetty!`,
    },

    jobAdApplications: {
      endTime: date => (date ? `, hakuaika päättyy ${date}` : ''),
      title: 'Kaikki hakemukset',
      sort: {
        updatedAt: 'Viimeksi muokattu',
        name: 'Nimi',
        rating: 'Arvosana',
        createdAt: 'Luontipäivämäärä',
      },
      add: 'Lisää uusi hakija',
      inviteToInterview: 'Kutsu haastatteluun',
      sendMessage: 'Lähetä viesti',
      changeStage: 'Siirrä toiseen vaiheeseen',
      introduce: 'Esittele',
      editIntroduceBatches: 'Muokkaa esittelyjä',
      filter: 'Etsi hakemuksia',
      hideFilters: 'Piilota suodattimet',
      showFilters: 'Näytä suodattimet',
      addInterviewConfirm: jobAd => `Haluatko luoda uuden videohaastattelun ja liittää sen työpaikkaan "${jobAd}" ?`,
    },

    adminJobAdApplication: {
      name: 'Nimi',
      email: 'Sähköposti',
      phone: 'Puhelinnumero',
      city: 'Kaupunki',
      back: 'Takaisin',
      continue: 'Jatka',
      submit: 'Lisää',
      namePlaceholder: 'Hakijan nimi',
      emailPlaceholder: 'Hakijan sähköposti',
      phonePlaceholder: 'Hakijan puhelinnumero',
      cityPlaceholder: 'Hakijan nykyinen kotikaupunki',
      links: 'Lisää linkkejä, esim. LinkedIn -profiili',
      legendBasicInfo: 'Perustiedot',
      legendLinks: 'Linkit',
      legendAttachments: 'Liitetiedostot',
      legendAdditionalFields: 'Lisätietoja',
      coverLetter: 'Saatekirje',
      attachments: 'Liitteet',
      introduction: 'Kirjoita tähän vapaamuotoinen saatekirje',
      readyInfo: 'Kiitos. Hakija on nyt lisätty työpaikkaan.',
      close: 'Sulje',
      required: '* Tähdellä merkityt kentät ovat pakollisia.',
      excel: 'Lataa hakijoiden tiedot exceliin',
    },

    jobAdEdit: {
      preview: 'Esikatselu',
      confirm: 'Haluatko varmasti luoda työpaikan?',
      deleteHeader: 'Haluatko varmasti poistaa työpaikan?',
      deleteContent: 'Työpaikan poistaminen poistaa myös kaikki työpaikkailmoitukseen liittyvät tiedot kuten hakijat ja videohaastattelut.',
      titlePlaceholder: 'Otsikko',
      locationPlaceholder: 'Sijainti',
      endTimePlaceholder: 'Voimassa',
      endTimeTooltip: 'Lisää päivämäärä, jolloin hakuaika päättyy automaattisesti.',
      timezone: 'Aikavyöhyke',
      isNotPastDate: 'pvm on menneisyydessä.',
      publishTimePlaceholder: 'Julkaisupäivä',
      publishTimeTooltip: 'Lisää päivämäärä, jolloin työpaikka tulee julkiseksi. Voit vaihtaa päivämäärää milloin haluat.',
      language: 'Ilmoituksen kieli',
      languagePlaceholder: 'Valitse',
      languages: {
        en: 'English',
        fi: 'Suomi',
      },
      description: 'Työn kuvaus',
      saved: 'Työpaikka tallennettu',
      deleted: 'Työpaikka poistettu',
      descriptionPlaceholder: 'Kirjoita työpaikan kuvausteksti tähän. \n\nVoit käyttää ylläolevia tekstin muotoilutoimintoja tehostamaan ilmoitusta.',
      createInviteOnly: 'Luo kutsupohjainen videohaastattelu',
      delete: 'Poista työpaikka',
      cancel: 'Peruuta',
      save: 'Tallenna',
      confirmLeave: 'Muutoksia ei ole tallennettu. Haluatko varmasti poistua?',
      singleHireEndError: 'Yksittäinen rekrytointi on voimassa 60 päivän ajan.',
      OnboardingHeadImageSize: 'Suositeltu taustakuvan koko on 1440px*320px tai korkeampi.',
    },

    jobAdPreview: {
      endTime: date => (date ? `, hakuaika päättyy ${date}` : ''),
      exit: 'Poistu esikatselusta',
      description: 'Työn kuvaus',
      video: 'Työnantajavideo',
      questions: 'Videokysymys',
      apply: 'Hae paikkaa',
    },

    jobAd: {
      endTime: date => (date ? `, hakuaika päättyy ${date}` : ''),
      changeStatus: 'Vaihda työpaikan statusta',
      edit: 'Muokkaa työpaikkaa',
      copy: 'Kopioi työpaikka',
      editInvitation: 'Muokkaa kutsuviestiä',
      editTeam: 'Muokkaa tiimiä',
      editMenu: 'Muokkaa',
      description: 'Työn kuvaus',
      video: 'Työnantajavideo',
      questions: 'Videokysymys',
      apply: 'Hae paikkaa',
      showApplications: 'Näytä hakemukset',
      publicLink: 'Työpaikan julkinen sivu',
      copySuccess: 'Työpaikka kopioitiin onnistuneesti',
    },

    status: {
      open: 'Avoin',
      filled: 'Täytetty',
      cancelled: 'Peruttu',
      done: 'Valmis',
      close: 'Sulje',
      closed: 'Suljettu',
      draft: 'Suljettu (luonnos)',
      hidden: 'Piilotettu',
      unpublished: 'Luonnos',
    },

    jobAds: {
      subscriptionNeeded: 'Tarvitset voimassa olevan tilauksen julkaistaksesi työpaikkailmoituksen.',
      responses: 'Hakemuksia',
      createNewJobPosition: 'Luo uusi työpaikka',
      allJobPositions: 'Kaikki työpaikat',
      confirmSingleHire: 'Ostamasi yksittäinen rekrytointi käytetään tähän työpaikkailmoitukseen.',
      filter: 'Etsi työpaikka',
      sort: {
        title: 'Otsikko',
        publishTime: 'Julkaisupäivä',
        applicationCount: 'Hakemuksia',
        endTime: 'Päättymisaika',
        createdAt: 'Luontipäivämäärä',
        updatedAt: 'Viimeksi muokattu',
      },
    },

    jobAdSaved: {
      title: 'Työpaikka tallennettu!',
      description: 'Työpaikka on nyt tallennettu. Tässä julkinen linkki työpaikkailmoitukseen:',
      addApplication: 'Suora linkki hakemuslomakkeelle:',
      toDashboard: 'Etusivulle',
      toJobAd: 'Takaisin työpaikan tietoihin',
    },

    interviewGuides: {
      allGuides: 'Kaikki haastatteluopaspohjat',
      createNewGuide: 'Luo uusi haastatteluopaspohja',
      noResults: 'Ei tuloksia.',
      sort: {
        title: 'Otsikko',
        createdAt: 'Luontiaika',
      },
    },

    interviewGuide: {
      headerTitle: 'Haastatteluopas',
      titleLabel: 'Haastatteluoppaan nimi',
      editTitle: 'Muokkaa haastatteluopasta',
      titlePlaceholder: 'Kirjoita haastatteluoppaan nimi',
      languageLabel: 'Haastatteluoppaan kieli',
      descriptionLabel: 'Kuvaus',
      descriptionPlaceholder: 'Kuvaa haastatteluoppaan käyttötarkoitus.',
      noDescription: 'Ei kuvausta.',
      saved: 'Haastatteluopas tallennettu',
      stepsLabel: 'Haastatteluoppaan osiot',
      stepsSubtitle: 'Määrittele haastattelun osiot.',
      deleted: 'Haastatteluopas poistettu',
      delete: 'Poista haastatteluopas',
      cancel: 'Peruuta',
      save: 'Tallenna haastatteluopas',
      ownerLabel: 'Omistaja',
      evaluationScale: 'Arviointiasteikko',
      confirmLeave:
        'Sinulla on tallentamattomia muutoksia. Haluatko varmasti poistua tältä sivulta?',
      confirmHeader: 'Haluatko varmasti poistaa tämän haastatteluoppaan?',
    },

    interviewRounds: {
      allRounds: 'Kaikki haastattelukierrokset',
      createNewRound: 'Luo uusi haastattelukierros',
      noResults: 'Ei haastattelukierroksia.',
      total: (count) => `${count} haastattelukierrosta`,
      sort: {
        title: 'Nimi',
        createdAt: 'Luontiaika',
        updatedAt: 'Viimeksi muokattu',
        endTime: 'Päättymisaika',
        owner: 'Omistaja',
      },
    },

    interviewRound: {
      languageAndGuideInfoTextTitle:
        'Kaikki haastattelut, jotka kuuluvat tähän haastattelukierrokseen, käyttävät kierrokselle asetettua kieltä ja haastatteluopasta.',
      languageAndGuideInfoText:
        "Kieltä tai haastatteluopasta ei voi tällä hetkellä muokata haastattelukohtaisesti. Et voi muokata haastattelukierroksen kieltä tai haastatteluopasta enää sen jälkeen, kun olet kutsunut hakijoita.",
      selectedCandidatesInfoText:
        'Osa valituista hakijoista on jo kutsuttu haastatteluun. Jos haluat päivittää haastattelun ajankohdan, voit tehdä sen avaamalla hakijan sivun.',
      closedWarningText: 'Haastattelukierroksen status on tällä hetkellä "suljettu". Haluatko ',
      closedLinkText: 'vaihtaa sen "avoimeksi"?',
      addCandidatesTitle: 'Lisää hakijoita',
      candidatesAdded: (count) => `${count} hakijaa lisätty haastattelukierrokseen.`,
      existingCandidates: (count) => `${count} hakijaa oli jo haastattelukierroksessa.`,
      scheduleInterview: 'Valitse haastattelun ajankohta',
      headerTitle: 'Haastattelukierros',
      titleLabel: 'Haastattelukierroksen nimi',
      languageLabel: 'Haastattelukierroksen kieli',
      endTimeLabel: 'Haastattelukierroksen päättymisaika',
      timezoneLabel: 'Aikavyöhyke',
      editTitle: 'Muokkaa haastattelukierrosta',
      titlePlaceholder: 'Kirjoita haastattelukierroksen nimi',
      interviewGuideLabel: details => details
        ? 'Haastatteluopas'
        : 'Valitse haastattelussa käytettävä haastatteluopas',
      noGuide: 'Ei valittua haastatteluopasta',
      noGuidesForLanguage: 'Haastatteluoppaita ei löytynyt valitulla kielellä',
      saved: 'Haastattelukierros tallennettu',
      deleted: 'Haastattelukierros poistettu',
      delete: 'Poista haastattelukierros',
      candidatesInvited: 'Kutsut lähetettiin hakijoille.',
      cancel: 'Peruuta',
      save: 'Tallenna haastattelukierros',
      ownerLabel: 'Omistaja',
      confirmLeave:
        'Sinulla on tallentamattomia muutoksia. Haluatko varmasti poistua tältä sivulta?',
      confirmHeader: 'Haluatko varmasti poistaa tämän haastattelukierroksen?',
      removeGuide: 'Tyhjennä haastatteluopas',
      noCandidates: 'Haastattelukierrokseen ei ole lisätty hakijoita.',
      changeStatus: 'Vaihda haastattelukierroksen status',
      sort: {
        updatedAt: 'Viimeksi muokattu',
        startTime: 'Haastattelun aloituspäivämäärä',
        name: 'Nimi',
        lastAccess: 'Viimeksi vieraillut',
        createdAt: 'Luontiaika',
      },
    },

    interviewInsights: {
      header: 'Haastatteluhavainnot',
      statisticalAnalysis: 'Tilastollinen analyysi',
      overallFeedback: 'Yleiskatsaus',
      detailedFeedback: 'Yksityiskohtainen analyysi',
      compliance: 'Vaatimustenmukaisuus',
      complianceIssue: 'Vaatimustenmukaisuusongelma',
      close: 'Sulje',
      speakingTime: 'Puheaika',
      candidate: 'Hakija',
      interviewer: 'Haastattelija',
      interviewersMultiple: 'Haastattelijat',
      adherence: {
        timeTable: 'Aikataulun noudattaminen',
        sections: 'Osiokohtainen aikataulun noudattaminen',
        questions: 'Vaatimustenmukaisuus kysymyksiin',
        talkRatio: 'Puheajan jakautuminen',
      },
      readMore: 'Lue lisää',
      analysis: 'Analyysi',
      sections: 'Osiot',
      details: 'Yksityiskohtainen palaute',
      proposedNextSteps: 'Ehdotetut seuraavat toimenpiteet',
      analysisInProgress: 'Analyysi käynnissä...',
      analysisFailed: 'Analyysin luonnissa tapahtui virhe.',
      tryAgainLater: 'Yritä myöhemmin uudelleen.',
      legalContext: 'Legal context',
    },

    live: {
      interviewersInfo:
        'Jos lisäät haastattelijoita, jotka eivät ole osa haastattelukierroksen rekrytointitiimiä, heidät lisätään haastattelukierroksen rekrytointitiimiin.',
      noStartTimeSelected: 'Aikaa ei ole valittu',
      noInterviewers: 'Ei haastattelijoita',
      title: 'Live-haastattelu',
      editTitle: 'Muokkaa live-haastattelua',
      startTimeTitle: 'Live-haastattelun ajankohta',
      startTime: 'Ajankohta',
      notScheduled: 'Aikaa ei ole valittu',
      interviewers: 'Haastattelijat',
      candidate: 'Hakija',
      candidates: 'Hakijat',
      candidateDisplayName: `Hakijan nimi`,
      messageLabel: 'Kutsuviesti',
      languageLabel: 'Kieli',
      create: 'Luo uusi',
      save: 'Tallenna muutokset',
      cancel: 'Peruuta',
      schedule: 'Valitse haastattelun mahdolliset ajankohdat',
      reschedule: 'Päivitä haastattelun ajankohta',
      removeLive: 'Poista haastattelu',
      cancelLive: 'Peruuta haastattelu',
      viewRecordings: 'Katso nauhoitukset',
      evaluationLabel: 'Arviointi',
      evaluationComparisonLabel: 'Arviointien vertailu',
      comment: 'Lisää muistiinpano',
      commentLabel: 'Muistiinpanot',
      interviewInsights: 'Haastatteluhavainnot',
      continueEvaluation: 'Jatka arviointia',
      transcriptButtonText: 'Haastattelun transkripti',
      interviewGuideLabel: details => details
        ? 'Haastatteluopas'
        : 'Valitse haastattelussa käytettävä haastatteluopas',
      noGuide: 'Ei valittua haastatteluopasta',
      interviewGuideInfo:
        'Voit käyttää haastatteluopasta vain, kun haastattelussa on yksi hakija.',
      enter: 'Siirry haastatteluun',
      edit: 'Muokkaa haastattelua',
      draft: 'Uusi Live-haastattelu',
      pending: 'Odotetaan hakijan vahvistamaa aikaa',
      scheduledLiveCandidateSubtitle:
        'Aikataulutettuun live-haastetteluun voi lisätä vain yhden kandidaatin.',
      confirmHeader: 'Oletko varma että haluat poistaa tämän Live-haastattelun?',
      inviteFailure: (success, failed) => `${success} kutsua lähetettiin ja ${failed} epäonnistui!`,
      inviteSuccess: success => `${success} kutsua lähetettiin.`,
      recordingsHeaderWithTitle: title =>
        `Live-haastattelun ${title} nauhoitukset`,
      recordingsHeader: `Live-haastattelun nauhoitukset`,
      success: {
        create: 'Uusi Live-haastattelu luotu',
        delete: 'Live-haastattelu poistettu',
        update: 'Live-haastattelu päivitetty',
      },
      placeholders: {
        candidateEmails: 'Lisää hakija',
        interviewerEmails: 'Lisää haastattelija',
        emailTitle: 'Kutsuviestin otsikko',
        emailMessage: 'Saate osallistujille',
        emailName: 'Nimi',
      },
      successInviteSent: 'Viesti haastatteluajan valinnasta lähetetty hakijalle.',
      errorInviteNotSent: 'Viestiä ei voitu lähettää.',
      startTimeChanged: 'Haastattelun ajankohta on päivitetty.',
      rescheduleConfirmBody: 'Oletko varma että haluat muuttaa haastattelun ajankohdan?',
      backToRound: 'Takaisin haastattelukierrokseen',
      schedulingInfo:
        'Voit käyttää kalenterointiin sellaisten haastattelun organisaatioon kuuluvien käyttäjien kalentereita, joiden kalenteri on yhdistetty Recrightiin ja jotka ovat haastattelijoita tässä haastattelussa.',
    },

    lives: {
      allLives: 'Kaikki Live-haastattelut',
      createNewLive: 'Luo uusi Live-haastattelu',
      filter: 'Etsi kandidaatin osoitteella',
      candidates: 'Hakijat',
      sort: {
        title: 'Otsikko',
        startTime: 'Ajankohta',
        createdAt: 'Luontiaika',
      },
    },

    login: {
      title: 'Kirjaudu palveluun',
      register: 'Rekisteröidy',
      forgot: 'Unohditko salasanasi?',
      normal: 'Tavallinen kirjautuminen',
      ssoLogin: 'SSO-kirjautuminen',
    },

    quickInterview: {
      title: 'Videoesittely',
      description: 'Vastaathan vielä allaolevaan kysymykseen lyhyellä videovastauksella. Tuo persoonasi esiin ja anna hakemuksellesi kasvot.',
      requiredNote: 'Huomaathan, että videoesittely on osa tätä hakuprosessia, ja rekrytoija näkee hakemuksesi vasta kun olet nauhoittanut vastauksen.',
      reminderNote: 'Voit nauhoittaa esittelyn heti tai jatkaa myöhemmin tilaamalla sähköpostiisi muistutusviestin.',
    },

    register: {
      title: 'Rekisteröidy käyttäjäksi',
      leadText: '',
      email: 'Sähköpostiosoite',
      submit: 'Rekisteröidy käyttäjäksi',
      alreadyMember: 'Rekisteröitynyt jo?',
      onlyForRecruiters: 'Rekisteröityminen on tarkoitettu rekrytoijille.',
      login: 'Kirjaudu täältä.',
      registerSuccess: 'Tarkista sähköpostisi ja rekisteröidy lähettämämme linkin kautta.',
      domainError: 'Käytäthän rekisteröitymiseen organisaatiosi sähköpostiosoitetta.',
      companyExistsMessage: 'Olemme lähettäneet sinulle ohjeet sähköpostiisi.',
    },

    searchResults: {
      title: 'Hakutulos',
      applications: 'Hakemukset',
      candidates: 'Videohaastatteluvastaukset',
      noApplications: 'Ei hakutermejä vastaavia hakemuksia',
      noCandidates: 'Ei hakutermejä vastaavia videovastauksia',
      query: query => (query ? `Hakutermit: ${query}` : ''),
      noStage: 'Ei vielä siirretty vaiheeseen',
      search: 'Etsi',
      itemsPerPage: 'Items per page',
    },

    statistics: {
      linkToDetailed: 'Tarkemmat tiedot',
      linkToSummary: 'Yhteenveto',
      summaryLeadText: 'Alla olevat luvut sisältävät kaikki aktiiviset positiot valitulla aikavälillä',
      detailsLeadText: 'Tällä sivulla on yksityiskohtaisia tietoja kaikista positioista, joissa on tapahtunut jotain valitulla aikavälillä.',
      export: 'Lataa tiedot exceliin',
      sort: {
        title: 'Otsikko',
        owner: 'Omistaja',
        createdAt: 'Luontiaika',
      },
      exportLimit:
        'Liian paljon tuloksia. Voit lyhentää valittua aikaväliä mahdollistaaksesi tietojen latauksen exceliin.',
      tooManyResults:
        'Liian paljon tuloksia. Voit lyhentää valittua aikaväliä nähdäksesi tulokset.',
    },

    welcome: {
      title: 'Rekisteröidy',
    },

    welcomeMulticompany: {
      welcome: companyName => `Tervetuloa ${companyName}-organisaatioon`,
      successMessage: companyName =>
        `Sinut on nyt lisätty organisaatioon ${companyName}!`,
      navigationInfo:
        'Voit vaihtaa aktiivista organisaatiotasi navigointivalikosta sivun oikeasta ylälaidasta.',
      login: 'Kirjaudu täältä',
    },

    forgotPassword: {
      title: 'Unohtuiko salasana?',
      email: 'Sähköpostiosoite',
      submit: 'Lähetä',
      sendEmail: 'Ei hätää, sellaista sattuu. Pääset vaihtamaan salasanasi helposti lähettämällä meille sen sähköpostiosoitteen, jota olet käyttänyt rekisteröityessäsi Recrightiin.',
      instructions: 'Siihen postilaatikkoon tupsahtaa pian ohjeet salasanan vaihtamiseksi.',
      success: 'Jos antamallasi sähköpostiosoitteella löytyi käyttäjä, Ohjeet salasanan vaihtamiseen on lähetetty kyseiseen osoitteeseen.',
    },

    changePassword: {
      title: 'Aseta uusi salasana',
      name: 'Nimi',
      email: 'Sähköpostiosoite',
      password: 'uusi salasana',
      confirmPassword: 'vahvista uusi salasana',
      submit: 'Vaihda salasana',
      error: {
        password: {
          isRequired: 'Salasana on pakollinen. ',
          isValidPassword: 'Salasanan pitää olla vähintään 12 merkkiä pitkä ja siinä pitää olla ainakin yksi iso kirjain, yksi pieni kirjain ja yksi numero',
          passwordsMatch: 'Salasanat eivät täsmää. ',
        },
      },
    },

    ssoLogin: {
      title: 'SSO-kirjautuminen',
      description: 'Kirjaudu sisään organisaatiotililläsi',
      info: 'Ulkoista tunnistautumista ei ole määritelty. Käytäthän',
      normalLoginLinkText: 'tavallista kirjautumista.',
      submit: 'Kirjaudu palveluun',
    },

    subscribe: {
      title: 'Tilaus',
      submit: 'Tilaa',
      creditCard: 'Luottokortti',
      cvv: 'CVV',
      expirationDate: 'Luottokortin päättymispäivä',
      vatAdvice: 'Antamalla VAT-numeron emme lisää tilaukseen arvonlisäveroa.',
      vatId: 'VAT-numero',
      vatHelp: 'VAT-numero on yritysten kansainvälinen alv-tunniste. VAT-numero sisältää maatunnuksen sekä yrityksen Y-tunnuksen ilman väliviivaa.',
      includeVat: 'sis. ALV',
      firstName: 'Etunimi',
      lastName: 'Sukunimi',
      email: 'Sähköposti',
      company: 'Yritys',
      street: 'Katuosoite',
      postalCode: 'Postinumero',
      city: 'Kaupunki',
      country: 'Maa',
      emptyCardFields: 'Ole hyvä ja täytä luottokorttitiedot.',
      invalidValue: 'Tarkista kohdan tiedot',
      planNotSelected: 'Valitse tilaus',
      totalPrice: 'Kokonaissumma',
      subscribed: 'Mahtavaa! Tilisi on nyt aktiivinen.',
      subscriptionExists: 'Yritykselläsi näyttää olevan voimassa oleva tilaus. Ole hyvä ja kirjaudu sisään tehdäksesi muutoksia.',
      agreeTos: 'Olen lukenut ja hyväksyn ',
      agreeTosLinkText: 'Recrightin käyttöehdot.',
      privacyPolicy: 'Arvostamme yksityisyyttäsi. Tutustuthan ',
      privacyPolicyLinkText: 'Tietosuojaselosteeseemme.',
      licenseAgreement: 'Hyväksyn edustamani yrityksen puolesta ',
      licenseAgreementLinkText: 'Recrightin käyttöoikeussopimuksen.',
      newsletter: 'Tilaan kuukausittaisen uutiskirjeen.',
      neverExpiresDiscount: amount => `Sisältää jatkuvan alennuksen ${amount} EUR`,
      fixedPeriodDiscount: (amount, cycles) => `Sisältää ${amount} EUR suuruisen alennuksen ${cycles} ensimmäiselle kuukaudelle.`,
      errorFromProcessor: error => `Maksunkäsittelijä palautti seuraavan virheen: ${error}`,
    },

    videos: {
      title: 'Videokirjasto',
      add: 'Lisää uusi video',
      rename: 'Nimeä uudelleen',
      remove: 'Poista',
      yourVideos: 'Omat videosi',
      companyVideos: 'Organisaation videot',
      confirmDeleteVideoTitle: 'Oletko varma, että haluat poistaa tämän videon?',
      confirmDeleteVideoMessage: 'Tämä poistaa videon videokirjastosta ja kaikista kokoelmista.',
      addToCollection: 'Lisää kokoelmaan',
    },

    userManagement: {
      excel: 'Lataa kaikki käyttäjät exceliin',
      title: 'Käyttäjien hallinta',
      showCompanyDefaultPermissions: 'Muokkaa yrityksen oletusoikeuksia',
      activateUserConfirm: 'Haluatko varmasti aktivoida käyttäjätunnuksen?',
      deactivateUserConfirm: 'Haluatko varmasti sulkea käyttäjätunnuksen?',
      showActivatedUsers: 'Näytä aktiiviset käyttäjät',
      showDeactivatedUsers: 'Näytä suljetut käyttäjät',
      confirmCancelEditPermissions: {
        message: 'Hylätäänkö muutokset?',
        cancel: 'Takaisin',
        confirm: 'Hylkää muutokset',
      },
      unsavedChanges: 'Tallenna muutokset ennen jatkamista',
      confirm: 'Tallenna',
      permissionsChangesSaved: 'Käyttöoikeudet tallennettu!',
      userDeactivated: nameOrEmail => `${nameOrEmail} suljettu`,
      userActivated: nameOrEmail => `${nameOrEmail} aktivoitu`,
      companyDefaultsSaved: 'Oletuskäyttöoikeudet tallennettu onnistuneesti!',
      usersAddAdded: success => `${success} käyttäjää lisätty.`,
      usersAddExist: exist => ` ${exist} käyttäjää löytyvätj jo palvelusta.`,
      excel: 'Lataa kaikki käyttäjät exceliin',
    },

  },

}
